import Vue from "vue";
import VueI18n from "vue-i18n";
import localizedStrings from "./localized_strings.json";

Vue.use(VueI18n);

// Define your translations
const messages = {
  en: localizedStrings,
  pt: {
    "menu.fleet": "Frota",
    "menu.maps": "Mapas",
    "menu.ships": "Navios",
    "menu.transactions": "Transação",
    "menu.deliveries": "Entregas",
    "menu.folio": "Fólio",
    "menu.shipFolio": "Fólio do Navio",
    "menu.orders": "Pedidos",
    "menu.logbook": "Diário de Bordo",
    "menu.webDis": "Web-DIS",
    "menu.navigation": "Navegação",
    "menu.connect": "Conectar",
    "menu.editor": "Editor",
    "menu.help": "Ajuda",
    "tabs.ports": "Portos",
    "tabs.routes": "Rotas",
    "tabs.settings": "Configurações",
    "tabs.files": "Arquivos",
    "tabs.wp": "WP",
    "tabs.generalRoute": "Geral",
    "tabs.ukc": "UKC",
    "tabs.pplan": "P.Plan",
    "tabs.weather": "Tempo",
    "tabs.folio": "Fólio",
    "tabs.order": "Pedido",
    "btn.ok": "OK",
    "btn.cancel": "Cancelar",
    "btn.close": "Fechar",
    "btn.clear": "Limpar",
    "btn.submit": "Enviar",
    "btn.save": "Salvar",
    "btn.add": "Adicionar",
    "btn.delete": "Excluir",
    "btn.edit": "Editar",
    "btn.search": "Buscar",
    "text.internetIsLost":
      "Sua conexão com a Internet foi perdida. O site funciona em modo restrito.",
    "menu.profile": "Perfil",
    "menu.signOut": "Sair",
    "trans.delivery": "ENTREGA",
    "trans.afterClickOrderDownloading":
      "Após clicar no botão, o pedido começará a ser baixado. Observe que o download pode levar alguns minutos.",
    "trans.items": "ITENS",
    "trans.shipName": "Nome do navio:",
    "trans.paymentBy": "Pagamento por:",
    "trans.agreement": "acordo",
    "trans.created": "Criado",
    "trans.paid": "Pago",
    "trans.cells": "Células",
    "trans.copyENCids": "copiar IDs ENC para área de transferência",
    "trans.orderUpdates": "ATUALIZAÇÕES DO PEDIDO",
    "trans.loadingShips": "Carregando navios...",
    "loading.tasksRemaining": "{count} tarefas restantes",
    "loading.updatingTransactions": "Atualizando transações...",
    "loading.loadingTransactions": "Carregando transações...",
    "loading.loadingShips": "Carregando navios...",
    "loading.loadingAgreements": "Carregando acordos...",
    "trans.loadingAgreement": "Carregando acordos...",
    "trans.orderOutdated": "O pedido está desatualizado",
    "trans.checkUpdates": "Verificar atualizações",
    "trans.loading": "Carregando...",
    "trans.edit": "Editar",
    "trans.request": "Solicitar",
    "trans.topay": "A pagar",
    "trans.cancel": "Cancelar",
    "login.login": "Entrar",
    "login.logInToAccount": "Faça login em sua conta",
    "login.registration": "Novo Cliente",
    "login.regSuccess":
      "Registro bem-sucedido. Obrigado por se registrar. Verifique seu e-mail para obter uma senha.",
    "login.regNotSuccess":
      "O registro não foi bem-sucedido. Provavelmente o e-mail já está registrado.",
    "login.submit": "Enviar",
    "login.howToGetStarted": "Como começar",
    "login.submitYourEmail":
      "Envie seu e-mail válido e receba a senha nele. Digite a senha e o registro está concluído.",
    "login.howToPurchase": "Como comprar ENCs",
    "login.enterCredentials":
      "Digite suas credenciais e selecione seu dispositivo móvel ativado ou conta ECDIS para ter acesso ao catálogo eletrônico.",
    "login.youMayPurchase":
      "Você pode comprar fólios de mapas prontos como Noruega ou Estônia, mapas dos EUA são gratuitos. No caso do PRIMAR, você deve selecionar os ENCs desejados do mapa WEB ou através das funções Maps Booster e prosseguir com os pagamentos. O histórico de pedidos e logs de pagamento são preservados.",
    "login.systemAutoPrevents":
      "O sistema previne automaticamente a compra dupla de mapas e pode ajudar na seleção de mapas pela rota que pode ser calculada automaticamente e corrigida pelo editor gráfico.",
    "login.news": "Notícias",
    "login.incorrectCredentials": "Nome de usuário ou senha incorretos",
    "login.toPurchaseENCsRegister":
      "Para comprar ENCs e Publicações Náuticas no portal WEB, você precisa estar registrado via aplicativo móvel.",
    "mobile.rotatePhone":
      "Gire seu telefone para paisagem e pressione o botão Entrar",
    "mobile.login": "Entrar",
    "navigation.title": "Navegação Web-DIS",
    "navigation.controls": "Controles de Navegação",
    "navigation.mapControl": "Controle do Mapa",
    "navigation.tilt": "Inclinação",
    "navigation.rotation": "Rotação",
    "navigation.zoom": "Zoom",
    "navigation.movement": "Movimento",
    "navigation.display": "Configurações de Exibição",
    "navigation.showGrid": "Mostrar Grade",
    "navigation.showCompass": "Mostrar Bússola",
    "navigation.nightMode": "Modo Noturno",
    "navigation.position": "Informações de Posição",
    "navigation.scale": "Escala",
    "navigation.zoomIn": "Ampliar",
    "navigation.zoomOut": "Reduzir",
    "test.mapDrawing": "Desenho do Mapa",
    "test.imageHandling": "Manipulação de Imagem",
    "test.chartsOnRoute": "Cartas na rota",
    "test.waypoints": "Waypoints",
    "test.distance": "Distância (km)",
    "test.band": "Banda",
    "ecdis.registration": "Registro ECDIS",
    "ecdis.ecdis": "ECDIS",
    "ecdis.save": "Salvar",
    "ecdis.add": "Adicionar",
    "ecdis.nowYouCan": "Agora você pode visitar a",
    "ecdis.andSelect":
      "aba e selecionar o dispositivo ECDIS para comprar cartas.",
    "ecdis.mydevices": "Meus Dispositivos",
    "ecdis.email": "E-mail",
    "ecdis.shipName": "Nome do navio",
    "ecdis.country": "País",
    "ecdis.category": "Categoria",
    "ecdis.ecdisBrand": "Marca ECDIS",
    "ecdis.ecdisOs": "SO ECDIS",
    "ecdis.ecdisType": "Tipo ECDIS",
    "ecdis.permit": "Permissão",
    "ecdis.selectCountry": "Selecione seu país",
    "ecdis.selectCategory": "Selecione uma categoria",
    "logbook.loadingShips": "Carregando navios...",
    "logbook.loadingAgreements": "Carregando acordos...",
    "logbook.webDisInfo":
      "O Diário de Bordo agora faz parte do sistema Web-DIS. Use o menu Web-DIS para navegar entre Diário de Bordo e Navegação.",
    "logbook.addReport": "Adicionar Relatório",
    "logbook.lat": "LAT",
    "logbook.lon": "LON",
    "logbook.hdg": "HDG",
    "logbook.sog": "SOG",
    "logbook.message": "Mensagem",
    "logbook.cancel": "Cancelar",
    "logbook.saveReport": "Salvar Relatório",
    "logbook.link": "link",
    "logbook.ecdis": "ecdis",
    "logbook.logbook": "DIÁRIO DE BORDO",
    "logbook.images": "Imagens",
    "logbook.audio": "Áudio",
    "logbook.selectImages": "Selecionar imagens...",
    "logbook.navStatus": "Status de Navegação",
    "logbook.cog": "COG",
    "logbook.rot": "ROT",
    "logbook.underCommand": "Sob comando",
    "logbook.atAnchor": "Ancorado",
    "logbook.notUnderCommand": "Sem comando",
    "logbook.restrictedManeuverability": "Manobrabilidade restrita",
    "logbook.constrainedByDraught": "Limitado pelo calado",
    "logbook.moored": "Amarrado",
    "logbook.aground": "Encalhado",
    "logbook.engagedInFishing": "Engajado na pesca",
    "logbook.underwaySailing": "Em navegação à vela",
    "logbook.reservedForHSC": "Reservado para HSC",
    "logbook.reservedForWIG": "Reservado para WIG",
    "logbook.reserved": "Reservado",
    "logbook.aisSartActive": "AIS-SART (ativo)",
    "logbook.notDefined": "Não definido",
    "general.primary": "Primário",
    "general.backup": "Backup",
    "general.windows": "Windows",
    "general.linux": "Linux",
    "general.android": "Android",
    "general.type": "Tipo",
    "general.period": "Período",
    "general.validTill": "Válido até",
    "general.yes": "Sim",
    "general.no": "Não",
    "general.enc": "ENC",
    "general.avcs": "AVCS",
    "general.adp": "ADP",
    "breadcrumb.ports": "Portos",
    "breadcrumb.routes": "Rotas",
    "breadcrumb.settings": "Configurações",
    "breadcrumb.files": "Arquivos",
    "breadcrumb.general": "Geral",
    "breadcrumb.wp": "WP",
    "breadcrumb.ukc": "UKC",
    "breadcrumb.pplan": "P.Plan",
    "breadcrumb.weather": "Tempo",
    "breadcrumb.navarea": "Navarea",
    "breadcrumb.aio": "AIO",
    "breadcrumb.folio": "Fólio",
    "breadcrumb.order": "Pedido",
    "connect.loadingShips": "Carregando navios...",
    "connect.loadingAgreements": "Carregando acordos...",
    "connect.connectPanel": "PAINEL DE CONTROLE ECDIS",
    "connect.getPosition": "Obter posição",
    "connect.getStatus": "Obter status",
    "connect.getRoute": "Obter rota",
    "connect.getFolio": "Obter fólio",
    "connect.requesting": "Solicitando...",
    "qr.scanInstructions": "Escanear código QR (info) do mKart MEGA ECDIS",
    "qr.uploadInstructions": "Carregar código QR (info) do mKart MEGA ECDIS",
    "fleet.fleet": "Frota",
    "fleet.addShip": "Adicionar",
    "fleet.addECDIS": "Adicionar ECDIS",
    "fleet.addByQR": "Adicionar por código QR",
    "fleet.addManually": "Adicionar Manualmente",
    "fleet.account": "Conta",
    "fleet.latest": "Último",
    "fleet.more": "mais",
    "fleet.noOrders": "sem pedidos",
    "fleet.deliveries": "entregas",
    "fleet.deviceid": "ID do Dispositivo",
    "general.autoband": "Banda automática",
    "general.overview": "Visão geral",
    "general.distributors": "Distribuidores",
    "general.geoPhone": "GeoPhone Group International OY",
    "general.distributorsList":
      "Encontre abaixo a lista de nossos distribuidores certificados.",
    "general.loadingFleetData": "Carregando dados da frota",
    "general.noPosition": "sem posição",
    "general.dataProvider": "Provedor de dados",
    "general.latLon": "Lat/Lon",
    "general.hazards": "Perigos",
    "general.speed": "Velocidade",
    "general.eta": "ETA",
    "general.length": "Comprimento",
    "general.startTime": "Hora de início:",
    "general.totalLength": "Comprimento total:",
    "general.checkRouteSafety": "Verificar segurança da rota",
    "general.loading": "Carregando...",
    "general.loadingEllipsis": "carregando...",
    "general.pleaseSelectPng": "Por favor, selecione um arquivo de imagem PNG.",
    "general.uploadImage": "Enviar Imagem",
    "distributors.title": "Distribuidores",
    "distributors.subtitle": "Selecione seu distribuidor certificado",
    "distributors.agreementStatus": "Status do Acordo",
    "distributors.shipInfo": "Informações do Navio",
    "distributors.hasAgreement": "Este navio é atendido por acordo",
    "distributors.agreementDetails": "Detalhes do Acordo",
    "distributors.noAgreement": "Este navio não está conectado a nenhum acordo",
    "distributors.needAgreement":
      "Para acessar os serviços do distribuidor, você precisa se conectar a um acordo",
    "distributors.contactSupport":
      "Entre em contato com o suporte para obter assistência",
    "distributors.selectDistributor":
      "Por favor, selecione um distribuidor abaixo:",
    "distributors.subscriptionOptions": "Opções de Assinatura",
    "distributors.subscribe": "Assinar",
    "distributors.contactEmail": "Contato via E-mail",
    "distributors.location": "Localização",
    "distributors.services": "Serviços",
    "distributors.support": "Suporte",
    "distributors.loading": "Carregando distribuidores...",
    "distributors.noDistributors": "Nenhum distribuidor disponível",
    "distributors.error": "Erro ao carregar distribuidores",
    "distributors.retry": "Tentar novamente",
    "distributors.back": "Voltar ao Principal",
    "distributors.selectShipFirst": "Por favor, selecione um navio primeiro",
    "distributors.agreementId": "ID do Acordo",
    "distributors.agreementName": "Nome do Acordo",
    "distributors.shipName": "Nome do Navio",
    "distributors.dataProvider": "Provedor de Dados",
  },
  ja: {
    "menu.fleet": "艦隊",
    "menu.maps": "海図",
    "menu.ships": "船舶",
    "menu.transactions": "取引",
    "menu.deliveries": "配信",
    "menu.folio": "フォリオ",
    "menu.shipFolio": "船舶フォリオ",
    "menu.orders": "注文",
    "menu.logbook": "航海日誌",
    "menu.webDis": "Web-DIS",
    "menu.navigation": "ナビゲーション",
    "menu.connect": "接続",
    "menu.editor": "エディター",
    "menu.help": "ヘルプ",
    "tabs.ports": "港湾",
    "tabs.routes": "ルート",
    "tabs.settings": "設定",
    "tabs.files": "ファイル",
    "tabs.wp": "WP",
    "tabs.generalRoute": "一般",
    "tabs.ukc": "UKC",
    "tabs.pplan": "P.Plan",
    "tabs.weather": "天気",
    "tabs.folio": "フォリオ",
    "tabs.order": "注文",
    "btn.ok": "OK",
    "btn.cancel": "キャンセル",
    "btn.close": "閉じる",
    "btn.clear": "クリア",
    "btn.submit": "送信",
    "btn.save": "保存",
    "btn.add": "追加",
    "btn.delete": "削除",
    "btn.edit": "編集",
    "btn.search": "検索",
    "text.internetIsLost":
      "インターネット接続が失われました。サイトは制限モードで動作しています。",
    "menu.profile": "プロフィール",
    "menu.signOut": "サインアウト",
    "trans.delivery": "配信",
    "trans.afterClickOrderDownloading":
      "ボタンをクリックすると、注文のダウンロードが開始されます。ダウンロードには数分かかる場合があります。",
    "trans.items": "アイテム",
    "trans.shipName": "船名：",
    "trans.paymentBy": "支払い方法：",
    "trans.agreement": "契約",
    "trans.created": "作成済み",
    "trans.paid": "支払済み",
    "trans.cells": "セル",
    "trans.copyENCids": "ENC IDをクリップボードにコピー",
    "trans.orderUpdates": "注文更新",
    "trans.loadingShips": "船舶を読み込み中...",
    "loading.tasksRemaining": "残り{count}タスク",
    "loading.updatingTransactions": "取引を更新中...",
    "loading.loadingTransactions": "取引を読み込み中...",
    "loading.loadingShips": "船舶を読み込み中...",
    "loading.loadingAgreements": "契約を読み込み中...",
    "trans.loadingAgreement": "契約を読み込み中...",
    "trans.orderOutdated": "注文が古くなっています",
    "trans.checkUpdates": "更新確認",
    "trans.loading": "読み込み中...",
    "trans.edit": "編集",
    "trans.request": "リクエスト",
    "trans.topay": "支払い予定",
    "trans.cancel": "キャンセル",
    "login.login": "ログイン",
    "login.logInToAccount": "アカウントにログイン",
    "login.registration": "新規顧客",
    "login.regSuccess":
      "登録が成功しました。登録していただきありがとうございます。パスワードについてはメールを確認してください。",
    "login.regNotSuccess":
      "登録に失敗しました。おそらくメールは既に登録されています。",
    "login.submit": "送信",
    "login.howToGetStarted": "始め方",
    "login.submitYourEmail":
      "有効なメールアドレスを送信してパスワードを取得してください。パスワードを入力すると登録完了です。",
    "login.howToPurchase": "ENCの購入方法",
    "login.enterCredentials":
      "認証情報を入力し、アクティブ化されたモバイルデバイスまたはECDISアカウントを選択して電子カタログにアクセスしてください。",
    "login.youMayPurchase":
      "ノルウェーやエストニアのような既製の海図フォリオを購入できます。米国の海図は無料です。PRIMARの場合は、WEBマップまたはMaps Booster機能から希望のENCを選択し、支払いを進めてください。注文履歴と支払いログは保存されます。",
    "login.systemAutoPrevents":
      "システムは海図の重複購入を自動的に防ぎ、自動計算およびグラフィックエディターで修正可能なルートによる海図選択を支援できます。",
    "login.news": "ニュース",
    "login.incorrectCredentials":
      "ユーザー名またはパスワードが正しくありません",
    "login.toPurchaseENCsRegister":
      "WEBポータルでENCと海図書誌を購入するには、モバイルアプリで登録する必要があります。",
    "mobile.rotatePhone": "電話を横向きにしてログインボタンを押してください",
    "mobile.login": "ログイン",
    "navigation.title": "Web-DISナビゲーション",
    "navigation.controls": "ナビゲーションコントロール",
    "navigation.mapControl": "マップコントロール",
    "navigation.tilt": "チルト",
    "navigation.rotation": "回転",
    "navigation.zoom": "ズーム",
    "navigation.movement": "移動",
    "navigation.display": "表示設定",
    "navigation.showGrid": "グリッド表示",
    "navigation.showCompass": "コンパス表示",
    "navigation.nightMode": "ナイトモード",
    "navigation.position": "位置情報",
    "navigation.scale": "スケール",
    "navigation.zoomIn": "拡大",
    "navigation.zoomOut": "縮小",
    "test.mapDrawing": "マップ描画",
    "test.imageHandling": "画像処理",
    "test.chartsOnRoute": "ルート上の海図",
    "test.waypoints": "ウェイポイント",
    "test.distance": "距離（km）",
    "test.band": "バンド",
    "ecdis.registration": "ECDIS登録",
    "ecdis.ecdis": "ECDIS",
    "ecdis.save": "保存",
    "ecdis.add": "追加",
    "ecdis.nowYouCan": "次のページにアクセスできます",
    "ecdis.andSelect":
      "タブを選択してECDISデバイスを選んで海図を購入してください。",
    "ecdis.mydevices": "マイデバイス",
    "ecdis.email": "メール",
    "ecdis.shipName": "船名",
    "ecdis.country": "国",
    "ecdis.category": "カテゴリー",
    "ecdis.ecdisBrand": "ECDISブランド",
    "ecdis.ecdisOs": "ECDIS OS",
    "ecdis.ecdisType": "ECDISタイプ",
    "ecdis.permit": "許可",
    "ecdis.selectCountry": "国を選択してください",
    "ecdis.selectCategory": "カテゴリーを選択してください",
    "logbook.loadingShips": "船舶を読み込み中...",
    "logbook.loadingAgreements": "契約を読み込み中...",
    "logbook.webDisInfo":
      "航海日誌はWeb-DISシステムの一部になりました。航海日誌とナビゲーション間を移動するにはWeb-DISメニューを使用してください。",
    "logbook.addReport": "レポート追加",
    "logbook.lat": "LAT",
    "logbook.lon": "LON",
    "logbook.hdg": "HDG",
    "logbook.sog": "SOG",
    "logbook.message": "メッセージ",
    "logbook.cancel": "キャンセル",
    "logbook.saveReport": "レポート保存",
    "logbook.link": "リンク",
    "logbook.ecdis": "ecdis",
    "logbook.logbook": "航海日誌",
    "logbook.images": "画像",
    "logbook.audio": "オーディオ",
    "logbook.selectImages": "画像を選択...",
    "logbook.navStatus": "ナビゲーション状況",
    "logbook.cog": "COG",
    "logbook.rot": "ROT",
    "logbook.underCommand": "操船中",
    "logbook.atAnchor": "錨泊中",
    "logbook.notUnderCommand": "操船不能",
    "logbook.restrictedManeuverability": "操縦制限中",
    "logbook.constrainedByDraught": "喫水制約中",
    "logbook.moored": "係留中",
    "logbook.aground": "座礁中",
    "logbook.engagedInFishing": "漁労中",
    "logbook.underwaySailing": "帆走中",
    "logbook.reservedForHSC": "HSC用予約",
    "logbook.reservedForWIG": "WIG用予約",
    "logbook.reserved": "予約済み",
    "logbook.aisSartActive": "AIS-SART（アクティブ）",
    "logbook.notDefined": "未定義",
    "general.primary": "プライマリ",
    "general.backup": "バックアップ",
    "general.windows": "Windows",
    "general.linux": "Linux",
    "general.android": "Android",
    "general.type": "タイプ",
    "general.period": "期間",
    "general.validTill": "有効期限",
    "general.yes": "はい",
    "general.no": "いいえ",
    "general.enc": "ENC",
    "general.avcs": "AVCS",
    "general.adp": "ADP",
    "breadcrumb.ports": "港湾",
    "breadcrumb.routes": "ルート",
    "breadcrumb.settings": "設定",
    "breadcrumb.files": "ファイル",
    "breadcrumb.general": "一般",
    "breadcrumb.wp": "WP",
    "breadcrumb.ukc": "UKC",
    "breadcrumb.pplan": "P.Plan",
    "breadcrumb.weather": "天気",
    "breadcrumb.navarea": "Navarea",
    "breadcrumb.aio": "AIO",
    "breadcrumb.folio": "フォリオ",
    "breadcrumb.order": "注文",
    "connect.loadingShips": "船舶を読み込み中...",
    "connect.loadingAgreements": "契約を読み込み中...",
    "connect.connectPanel": "ECDISコントロールパネル",
    "connect.getPosition": "位置取得",
    "connect.getStatus": "ステータス取得",
    "connect.getRoute": "ルート取得",
    "connect.getFolio": "フォリオ取得",
    "connect.requesting": "リクエスト中...",
    "qr.scanInstructions": "mKart MEGA ECDISからQRコード（情報）をスキャン",
    "qr.uploadInstructions":
      "mKart MEGA ECDISからQRコード（情報）をアップロード",
    "fleet.fleet": "艦隊",
    "fleet.addShip": "追加",
    "fleet.addECDIS": "ECDIS追加",
    "fleet.addByQR": "QRコードで追加",
    "fleet.addManually": "手動で追加",
    "fleet.account": "アカウント",
    "fleet.latest": "最新",
    "fleet.more": "もっと",
    "fleet.noOrders": "注文なし",
    "fleet.deliveries": "配送",
    "fleet.deviceid": "デバイスID",
    "general.autoband": "オートバンド",
    "general.overview": "概要",
    "general.distributors": "販売店",
    "general.geoPhone": "GeoPhone Group International OY",
    "general.distributorsList": "認定販売店のリストをご覧ください。",
    "general.loadingFleetData": "フリートデータを読み込み中",
    "general.noPosition": "位置なし",
    "general.dataProvider": "データプロバイダー",
    "general.latLon": "緯度/経度",
    "general.hazards": "危険",
    "general.speed": "速度",
    "general.eta": "ETA",
    "general.length": "長さ",
    "general.startTime": "開始時刻:",
    "general.totalLength": "総長:",
    "general.checkRouteSafety": "ルートの安全性を確認",
    "general.loading": "読み込み中...",
    "general.loadingEllipsis": "読み込み中...",
    "general.pleaseSelectPng": "PNGイメージファイルを選択してください。",
    "general.uploadImage": "画像をアップロード",
    "distributors.title": "販売店",
    "distributors.subtitle": "認定販売店を選択してください",
    "distributors.agreementStatus": "契約状況",
    "distributors.shipInfo": "船舶情報",
    "distributors.hasAgreement": "この船舶は契約によってサービスされています",
    "distributors.agreementDetails": "契約詳細",
    "distributors.noAgreement": "この船舶は契約に接続されていません",
    "distributors.needAgreement":
      "販売店サービスにアクセスするには、契約への接続が必要です",
    "distributors.contactSupport": "サポートにお問い合わせください",
    "distributors.selectDistributor": "以下から販売店を選択してください：",
    "distributors.subscriptionOptions": "サブスクリプションオプション",
    "distributors.subscribe": "購読する",
    "distributors.contactEmail": "メールで連絡",
    "distributors.location": "場所",
    "distributors.services": "サービス",
    "distributors.support": "サポート",
    "distributors.loading": "販売店を読み込み中...",
    "distributors.noDistributors": "利用可能な販売店がありません",
    "distributors.error": "販売店の読み込みエラー",
    "distributors.retry": "再試行",
    "distributors.back": "メインに戻る",
    "distributors.selectShipFirst": "最初に船舶を選択してください",
    "distributors.agreementId": "契約ID",
    "distributors.agreementName": "契約名",
    "distributors.shipName": "船舶名",
    "distributors.dataProvider": "データプロバイダー",
  },
  ru: {
    "menu.fleet": "Флот",
    "menu.maps": "Карты",
    "menu.ships": "Суда",
    "menu.transactions": "Транзакции",
    "menu.deliveries": "Доставки",
    "menu.folio": "Фолио",
    "menu.shipFolio": "Фолио судна",
    "menu.orders": "Заказы",
    "menu.logbook": "Судовой журнал",
    "menu.webDis": "Web-DIS",
    "menu.navigation": "Навигация",
    "menu.connect": "Подключение",
    "menu.editor": "Редактор",
    "menu.help": "Помощь",
    "tabs.ports": "Порты",
    "tabs.routes": "Маршруты",
    "tabs.settings": "Настройки",
    "tabs.files": "Файлы",
    "tabs.wp": "WP",
    "tabs.generalRoute": "Общий",
    "tabs.ukc": "UKC",
    "tabs.pplan": "П.План",
    "tabs.weather": "Погода",
    "tabs.folio": "Фолио",
    "tabs.order": "Заказ",
    "btn.ok": "ОК",
    "btn.cancel": "Отмена",
    "btn.close": "Закрыть",
    "btn.clear": "Очистить",
    "btn.submit": "Отправить",
    "btn.save": "Сохранить",
    "btn.add": "Добавить",
    "btn.delete": "Удалить",
    "btn.edit": "Редактировать",
    "btn.search": "Поиск",
    "text.internetIsLost":
      "Подключение к Интернету потеряно. Сайт работает в ограниченном режиме.",
    "menu.profile": "Профиль",
    "menu.signOut": "Выйти",
    "trans.delivery": "ДОСТАВКА",
    "trans.afterClickOrderDownloading":
      "После нажатия кнопки начнется загрузка заказа. Обратите внимание, что загрузка может занять несколько минут.",
    "trans.items": "ЭЛЕМЕНТЫ",
    "trans.shipName": "Название судна:",
    "trans.paymentBy": "Оплата:",
    "trans.agreement": "соглашение",
    "trans.created": "Создано",
    "trans.paid": "Оплачено",
    "trans.cells": "Ячейки",
    "trans.copyENCids": "копировать ID ENC в буфер обмена",
    "trans.orderUpdates": "ОБНОВЛЕНИЯ ЗАКАЗА",
    "trans.loadingShips": "Загрузка судов...",
    "loading.tasksRemaining": "Осталось {count} задач",
    "loading.updatingTransactions": "Обновление транзакций...",
    "loading.loadingTransactions": "Загрузка транзакций...",
    "loading.loadingShips": "Загрузка судов...",
    "loading.loadingAgreements": "Загрузка соглашений...",
    "trans.loadingAgreement": "Загрузка соглашений...",
    "trans.orderOutdated": "Заказ устарел",
    "trans.checkUpdates": "Проверить обновления",
    "trans.loading": "Загрузка...",
    "trans.edit": "Редактировать",
    "trans.request": "Запрос",
    "trans.topay": "К оплате",
    "trans.cancel": "Отмена",
    "login.login": "Вход",
    "login.logInToAccount": "Войдите в свой аккаунт",
    "login.registration": "Новый клиент",
    "login.regSuccess":
      "Регистрация прошла успешно. Спасибо за регистрацию. Проверьте свою почту для получения пароля.",
    "login.regNotSuccess":
      "Регистрация не удалась. Возможно, email уже зарегистрирован.",
    "login.submit": "Отправить",
    "login.howToGetStarted": "Как начать",
    "login.submitYourEmail":
      "Отправьте свой действительный email и получите пароль на него. Введите пароль и регистрация завершена.",
    "login.howToPurchase": "Как приобрести ENC",
    "login.enterCredentials":
      "Введите свои учетные данные и выберите активированное мобильное устройство или аккаунт ECDIS для доступа к электронному каталогу.",
    "login.youMayPurchase":
      "Вы можете приобрести готовые фолио карт, такие как Норвегия или Эстония, карты США бесплатны. В случае PRIMAR вам нужно выбрать желаемые ENC с WEB карты или через функции Maps Booster и продолжить с платежами. История заказов и логи платежей сохраняются.",
    "login.systemAutoPrevents":
      "Система автоматически предотвращает двойную покупку карт и может помочь с выбором карт по маршруту, который может быть рассчитан автоматически и исправлен графическим редактором.",
    "login.news": "Новости",
    "login.incorrectCredentials": "Неверное имя пользователя или пароль",
    "login.toPurchaseENCsRegister":
      "Для покупки ENC и навигационных публикаций на WEB портале вам необходимо зарегистрироваться через мобильное приложение.",
    "mobile.rotatePhone":
      "Поверните телефон в альбомную ориентацию и нажмите кнопку Вход",
    "mobile.login": "Вход",
    "navigation.title": "Навигация Web-DIS",
    "navigation.controls": "Элементы управления навигацией",
    "navigation.mapControl": "Управление картой",
    "navigation.tilt": "Наклон",
    "navigation.rotation": "Поворот",
    "navigation.zoom": "Масштаб",
    "navigation.movement": "Движение",
    "navigation.display": "Настройки отображения",
    "navigation.showGrid": "Показать сетку",
    "navigation.showCompass": "Показать компас",
    "navigation.nightMode": "Ночной режим",
    "navigation.position": "Информация о позиции",
    "navigation.scale": "Масштаб",
    "navigation.zoomIn": "Увеличить",
    "navigation.zoomOut": "Уменьшить",
    "test.mapDrawing": "Рисование карты",
    "test.imageHandling": "Обработка изображений",
    "test.chartsOnRoute": "Карты на маршруте",
    "test.waypoints": "Путевые точки",
    "test.distance": "Расстояние (км)",
    "test.band": "Диапазон",
    "ecdis.registration": "Регистрация ECDIS",
    "ecdis.ecdis": "ECDIS",
    "ecdis.save": "Сохранить",
    "ecdis.add": "Добавить",
    "ecdis.nowYouCan": "Теперь вы можете посетить",
    "ecdis.andSelect": "вкладку и выбрать устройство ECDIS для покупки карт.",
    "ecdis.mydevices": "Мои устройства",
    "ecdis.email": "Email",
    "ecdis.shipName": "Название судна",
    "ecdis.country": "Страна",
    "ecdis.category": "Категория",
    "ecdis.ecdisBrand": "Бренд ECDIS",
    "ecdis.ecdisOs": "ОС ECDIS",
    "ecdis.ecdisType": "Тип ECDIS",
    "ecdis.permit": "Разрешение",
    "ecdis.selectCountry": "Выберите вашу страну",
    "ecdis.selectCategory": "Выберите категорию",
    "logbook.loadingShips": "Загрузка судов...",
    "logbook.loadingAgreements": "Загрузка соглашений...",
    "logbook.webDisInfo":
      "Судовой журнал теперь является частью системы Web-DIS. Используйте меню Web-DIS для навигации между Судовым журналом и Навигацией.",
    "logbook.addReport": "Добавить отчет",
    "logbook.lat": "LAT",
    "logbook.lon": "LON",
    "logbook.hdg": "HDG",
    "logbook.sog": "SOG",
    "logbook.message": "Сообщение",
    "logbook.cancel": "Отмена",
    "logbook.saveReport": "Сохранить отчет",
    "logbook.link": "ссылка",
    "logbook.ecdis": "ecdis",
    "logbook.logbook": "СУДОВОЙ ЖУРНАЛ",
    "logbook.images": "Изображения",
    "logbook.audio": "Аудио",
    "logbook.selectImages": "Выбрать изображения...",
    "logbook.navStatus": "Навигационный статус",
    "logbook.cog": "COG",
    "logbook.rot": "ROT",
    "logbook.underCommand": "На ходу с машинной тягой",
    "logbook.atAnchor": "На якоре",
    "logbook.notUnderCommand": "Лишенное возможности управляться",
    "logbook.restrictedManeuverability":
      "Ограниченное в возможности маневрировать",
    "logbook.constrainedByDraught": "Стесненное своей осадкой",
    "logbook.moored": "Пришвартованное",
    "logbook.aground": "На мели",
    "logbook.engagedInFishing": "Занятое ловом рыбы",
    "logbook.underwaySailing": "На ходу под парусом",
    "logbook.reservedForHSC": "Зарезервировано для HSC",
    "logbook.reservedForWIG": "Зарезервировано для WIG",
    "logbook.reserved": "Зарезервировано",
    "logbook.aisSartActive": "AIS-SART (активный)",
    "logbook.notDefined": "Не определено",
    "general.primary": "Основной",
    "general.backup": "Резервный",
    "general.windows": "Windows",
    "general.linux": "Linux",
    "general.android": "Android",
    "general.type": "Тип",
    "general.period": "Период",
    "general.validTill": "Действителен до",
    "general.yes": "Да",
    "general.no": "Нет",
    "general.enc": "ENC",
    "general.avcs": "AVCS",
    "general.adp": "ADP",
    "breadcrumb.ports": "Порты",
    "breadcrumb.routes": "Маршруты",
    "breadcrumb.settings": "Настройки",
    "breadcrumb.files": "Файлы",
    "breadcrumb.general": "Общие",
    "breadcrumb.wp": "WP",
    "breadcrumb.ukc": "UKC",
    "breadcrumb.pplan": "П.План",
    "breadcrumb.weather": "Погода",
    "breadcrumb.navarea": "Navarea",
    "breadcrumb.aio": "AIO",
    "breadcrumb.folio": "Фолио",
    "breadcrumb.order": "Заказ",
    "connect.loadingShips": "Загрузка судов...",
    "connect.loadingAgreements": "Загрузка соглашений...",
    "connect.connectPanel": "ПАНЕЛЬ УПРАВЛЕНИЯ ECDIS",
    "connect.getPosition": "Получить позицию",
    "connect.getStatus": "Получить статус",
    "connect.getRoute": "Получить маршрут",
    "connect.getFolio": "Получить фолио",
    "connect.requesting": "Запрос...",
    "qr.scanInstructions": "Сканировать QR-код (информация) с mKart MEGA ECDIS",
    "qr.uploadInstructions": "Загрузить QR-код (информация) с mKart MEGA ECDIS",
    "fleet.fleet": "Флот",
    "fleet.addShip": "Добавить",
    "fleet.addECDIS": "Добавить ECDIS",
    "fleet.addByQR": "Добавить по QR-коду",
    "fleet.addManually": "Добавить вручную",
    "fleet.account": "Аккаунт",
    "fleet.latest": "Последний",
    "fleet.more": "больше",
    "fleet.noOrders": "нет заказов",
    "fleet.deliveries": "поставки",
    "fleet.deviceid": "ID устройства",
    "general.autoband": "Авто-диапазон",
    "general.overview": "Обзор",
    "general.distributors": "Дистрибьюторы",
    "general.geoPhone": "GeoPhone Group International OY",
    "general.distributorsList":
      "Ниже приведен список наших сертифицированных дистрибьюторов.",
    "general.loadingFleetData": "Загрузка данных флота",
    "general.noPosition": "нет позиции",
    "general.dataProvider": "Поставщик данных",
    "general.latLon": "Широта/Долгота",
    "general.hazards": "Опасности",
    "general.speed": "Скорость",
    "general.eta": "ETA",
    "general.length": "Длина",
    "general.startTime": "Время начала:",
    "general.totalLength": "Общая длина:",
    "general.checkRouteSafety": "Проверить безопасность маршрута",
    "general.loading": "Загрузка...",
    "general.loadingEllipsis": "загрузка...",
    "general.pleaseSelectPng": "Пожалуйста, выберите файл PNG изображения.",
    "general.uploadImage": "Загрузить изображение",
    "distributors.title": "Дистрибьюторы",
    "distributors.subtitle": "Выберите вашего сертифицированного дистрибьютора",
    "distributors.agreementStatus": "Статус договора",
    "distributors.shipInfo": "Информация о судне",
    "distributors.hasAgreement": "Данное судно обслуживается по договору",
    "distributors.agreementDetails": "Детали договора",
    "distributors.noAgreement": "Данный корабль не подключен к договору",
    "distributors.needAgreement":
      "Для доступа к услугам дистрибьюторов необходимо подключение к договору",
    "distributors.contactSupport": "Обратитесь в службу поддержки за помощью",
    "distributors.selectDistributor":
      "Пожалуйста, выберите дистрибьютора ниже:",
    "distributors.subscriptionOptions": "Варианты подписки",
    "distributors.subscribe": "Подписаться",
    "distributors.contactEmail": "Связаться по электронной почте",
    "distributors.location": "Местоположение",
    "distributors.services": "Услуги",
    "distributors.support": "Поддержка",
    "distributors.loading": "Загрузка дистрибьюторов...",
    "distributors.noDistributors": "Дистрибьюторы недоступны",
    "distributors.error": "Ошибка загрузки дистрибьюторов",
    "distributors.retry": "Повторить",
    "distributors.back": "Вернуться к главной",
    "distributors.selectShipFirst": "Сначала выберите судно",
    "distributors.agreementId": "ID договора",
    "distributors.agreementName": "Название договора",
    "distributors.shipName": "Название судна",
    "distributors.currentAgreement": "Текущий договор",
    "distributors.agreementActive": "Корабль обслуживается по договору",
    "distributors.canChangeDistributor":
      "При желании Вы можете сменить дистрибьютора, выбрав из списка ниже",
    "distributors.cardPaymentOnly":
      "В ином случае возможна только покупка карт с оплатой пластиковой картой",
    "distributors.serviceDescription":
      "Для доступа к сервису ECDIS-Link по покупке, доставке и управлению электронными навигационными картами (ENC) пользователям необходимо заключить договор с одним из официальных дистрибьюторов",
    "distributors.partnersInfo":
      "Наши авторизованные партнеры обеспечивают соответствие регуляторным стандартам и предоставляют локализованную поддержку для беспрепятственного управления картами и активации сервиса",
    "distributors.listTitle": "Сертифицированные дистрибьюторы",
    "distributors.listDescription":
      "Выберите дистрибьютора для заключения договора на обслуживание",
    "distributors.current": "Текущий",
    "distributors.dataProvider": "Data Provider",
    "distributors.languages": "Языки",
    "distributors.currentContract": "Действующий договор",
    "distributors.sendRequest": "Отправить заявку",
    "distributors.additionalInfo": "Дополнительная информация",
    "distributors.withAgreement": "С договором",
    "distributors.withoutAgreement": "Без договора",
    "distributors.fullAccess": "Полный доступ к сервисам",
    "distributors.creditPayment": "Оплата в кредит",
    "distributors.technicalSupport": "Техническая поддержка",
    "distributors.limitedAccess": "Ограниченный доступ",
    "distributors.cardOnly": "Только оплата картой",
    "distributors.noSupport": "Базовая поддержка",
    "distributors.emailSubject": "Заявка на заключение договора ECDIS-Link",
    "distributors.emailGreeting": "Здравствуйте!",
    "distributors.emailBody":
      "Меня интересует заключение договора на обслуживание корабля через сервис ECDIS-Link",
    "distributors.deviceId": "ID устройства",
    "distributors.emailClosing": "С уважением",
    "distributors.requestSent":
      "Заявка подготовлена. Проверьте ваш почтовый клиент",
    "distributors.success": "Успешно",
  },
  es: {
    "menu.fleet": "Flota",
    "menu.maps": "Mapas",
    "menu.ships": "Barcos",
    "menu.transactions": "Transacción",
    "menu.deliveries": "Entregas",
    "menu.logbook": "Diario de navegación",
    "menu.connect": "Conectar",
    "menu.editor": "Editor",
    "menu.help": "Ayuda",
    "tabs.ports": "Puertos",
    "tabs.routes": "Rutas",
    "tabs.settings": "Configuración",
    "tabs.files": "Archivos",
    "tabs.wp": "PR",
    "tabs.generalRoute": "General",
    "tabs.ukc": "UKC",
    "tabs.pplan": "Plan Nav.",
    "tabs.weather": "Tiempo",
    "tabs.folio": "Folio",
    "tabs.order": "Pedido",
    "btn.ok": "Aceptar",
    "btn.cancel": "Cancelar",
    "btn.close": "Cerrar",
    "btn.clear": "Limpiar",
    "btn.submit": "Enviar",
    "btn.save": "Guardar",
    "btn.add": "Añadir",
    "btn.delete": "Eliminar",
    "btn.edit": "Editar",
    "btn.search": "Buscar",
    "text.internetIsLost":
      "Se ha perdido la conexión a Internet. El sitio funciona en modo restringido.",
    "menu.profile": "Perfil",
    "menu.signOut": "Cerrar sesión",
    "trans.delivery": "ENTREGA",
    "trans.afterClickOrderDownloading":
      "Después de hacer clic en el botón, comenzará la descarga del pedido. Tenga en cuenta que la descarga puede tardar unos minutos.",
    "trans.items": "ARTÍCULOS",
    "trans.shipName": "Nombre del barco:",
    "trans.paymentBy": "Pago por:",
    "trans.agreement": "acuerdo",
    "trans.created": "Creado",
    "trans.paid": "Pagado",
    "trans.cells": "Celdas",
    "trans.copyENCids": "copiar IDs de ENC al portapapeles",
    "trans.orderUpdates": "ACTUALIZACIONES DE PEDIDO",
    "trans.loadingShips": "Cargando barcos...",
    "trans.loadingAgreement": "Cargando acuerdos...",
    "trans.orderOutdated": "El pedido está obsoleto",
    "trans.checkUpdates": "Verificar actualizaciones",
    "trans.loading": "Cargando ...",
    "trans.edit": "Editar",
    "trans.request": "Solicitar",
    "trans.topay": "Por pagar",
    "trans.cancel": "Cancelar",
    "login.login": "Iniciar sesión",
    "login.logInToAccount": "Iniciar sesión en su cuenta",
    "login.registration": "Registro",
    "login.regSuccess":
      "Registro exitoso. Gracias por registrarse. Por favor, revise su correo electrónico para obtener la contraseña.",
    "login.regNotSuccess":
      "El registro no se ha completado. Probablemente el correo electrónico ya está registrado.",
    "login.submit": "Enviar",
    "login.howToGetStarted": "Cómo comenzar",
    "login.submitYourEmail":
      "Ingrese su correo electrónico válido y reciba la contraseña en él. Ingrese la contraseña y el registro estará completo.",
    "login.howToPurchase": "Cómo comprar ENCs",
    "login.enterCredentials":
      "Ingrese sus credenciales y seleccione su dispositivo móvil activado o cuenta ECDIS para acceder al catálogo electrónico.",
    "login.youMayPurchase":
      "Puede comprar folios de mapas listos como Noruega o Estonia, los mapas de EE. UU. son gratuitos. En el caso de PRIMAR, debe seleccionar las ENCs deseadas del mapa WEB o mediante las funciones de Maps Booster y proceder con los pagos. El historial de pedidos y los registros de pagos se conservan.",
    "login.systemAutoPrevents":
      "El sistema evita automáticamente la compra doble de mapas y puede ayudar con la selección de mapas por la ruta que se puede calcular automáticamente y corregir mediante el editor gráfico.",
    "login.news": "Noticias",
    "mobile.rotatePhone":
      "Gire su teléfono a horizontal y presione el botón Iniciar sesión",
    "mobile.login": "Iniciar sesión",
    "payment.returnToOrders": "Volver a sus pedidos",
    "reg.registration": "Registro",
    "reg.regSuccess":
      "Registro exitoso. Gracias por registrarse. Por favor, revise su correo electrónico para obtener la contraseña.",
    "reg.regNotSuccess":
      "El registro no se ha completado. Probablemente el correo electrónico ya está registrado.",
    "reg.submit": "Enviar",
    "reg.incorrectPassword":
      "Contraseña incorrecta. Por favor, inténtelo de nuevo.",
    "ships.edit": "Editar",
    "ships.details": "DETALLES",
    "ships.deviceId": "ID del dispositivo:",
    "ships.email": "Correo electrónico:",
    "ships.shipName": "Nombre del barco:",
    "ships.category": "Categoría:",
    "ships.type": "Tipo:",
    "ships.brand": "Marca ECDIS:",
    "ships.imo": "IMO:",
    "ships.callsign": "Indicativo:",
    "ships.permit": "Permiso:",
    "ships.license": "Licencia:",
    "ships.licenseType": "Tipo de licencia:",
    "ships.licenseValid": "Licencia válida:",
    "ships.emails": "Correos electrónicos de notificación:",
    "ships.delveryEmails": "Correo electrónico de entrega:",
    "ships.charts": "Cartas:",
    "ships.expired": "expirado",
    "ships.loadingInstllations": "Cargando instalaciones...",
    "ships.noInfo":
      "No hay información disponible para el barco. Escanee el código QR del ECDIS para leer la información del barco",
    "ships.qrcode": "Código QR",
    "ships.report": "Informe",
    "ships.onmap": "En el mapa",
    "ships.view": "Ver",
    "ships.clear": "Limpiar",
    "ships.byqrcode": "Por código QR",
    "ships.manually": "Manualmente",
    "ships.selected": "Seleccionado",
    "ships.notSelected": "No seleccionado",
    "ship.addShip": "Añadir barco",
    "ship.shipName": "Nombre del barco",
    "ship.edit": "Editar",
    "ship.report": "Informe",
    "ship.viewEdit": "Ver/Editar barco",
    "ship.selectProvider": "Seleccionar un proveedor de datos",
    "ship.id": "ID",
    "ship.band": "Banda",
    "ship.ordered": "Pedido",
    "ship.daysValid": "Días válidos",
    "ships.mmsi": "MMSI:",
    "ships.callSign": "Indicativo:",
    "ships.country": "País:",
    "ships.length": "Eslora:",
    "ships.width": "Manga:",
    "ships.height": "Altura:",
    "ships.draught": "Calado:",
    "ships.shipCategory": "Categoría del barco:",
    "ships.os": "SO ECDIS:",
    "ships.permit1": "Permiso de respaldo 1:",
    "ships.permit2": "Permiso de respaldo 2:",
    "payment.placingOrder": "Realizando su pedido...",
    "payment.clickToPayment": "Haga clic para proceder al pago",
    "logbook.loadingShips": "Cargando barcos...",
    "logbook.loadingAgreements": "Cargando acuerdos...",
    "logbook.addReport": "Añadir informe",
    "logbook.lat": "LAT",
    "logbook.lon": "LON",
    "logbook.hdg": "HDG",
    "logbook.sog": "SOG",
    "logbook.message": "Mensaje",
    "logbook.cancel": "Cancelar",
    "logbook.saveReport": "Guardar informe",
    "logbook.link": "enlace",
    "logbook.ecdis": "ecdis",
    "editor.cancel": "Cancelar",
    "editor.save": "Guardar",
    "ecdis.ecdis": "ECDIS",
    "ecdis.save": "Guardar",
    "ecdis.add": "Añadir",
    "ecdis.nowYouCan": "Ahora puede visitar la",
    "ecdis.andSelect":
      "pestaña y seleccionar el dispositivo ECDIS para comprar cartas.",
    "ecdis.mydevices": "Mis dispositivos",
    "connect.loadingShips": "Cargando barcos...",
    "connect.loadingAgreements": "Cargando acuerdos...",
    "agreement.statusOwner": "Estado: propietario",
    "agreement.agrements": "Acuerdos",
    "agreement.loadings": "Cargando...",
    "agreement.noAgreements": "SIN ACUERDOS",
    "deliveries.loadingShips": "Cargando barcos...",
    "deliveries.loadingAgreements": "Cargando acuerdos...",
    "deliveries.checkUpdates": "Verificar actualizaciones",
    "deliveries.loading": "Cargando...",
    "deliveries.download": "Descargar",
    "routes.trafficSepZone": "Zona de separación de tráfico",
    "routes.inshoreTrafZone": "Zona de tráfico costero",
    "routes.restArea": "Zona restringida",
    "routes.cautionArea": "Zona de precaución",
    "routes.offshoreProdArea": "Zona de producción en alta mar",
    "routes.avoidedArea": "Zonas a evitar",
    "routes.militaryArea": "Zona de prácticas militares",
    "routes.seaplaneArea": "Zona de aterrizaje de hidroaviones",
    "routes.submarineLine": "Carril de tránsito submarino",
    "routes.anchorageArea": "Zona de fondeo",
    "routes.marineFarm": "Granja marina/acuicultura",
    "routes.pssa": "ZMES",
    "routes.showWind": "Mostrar viento",
    "routes.showTemp": "Mostrar temperatura",
    "routes.selectDateTime": "Seleccione fecha/hora primero",
    "routes.weatherNotAvailable":
      "El tiempo no está disponible para la ruta, recalcúlelo",
    "routes.weatherNotAvailableForRoute":
      "El tiempo no está disponible para la ruta",
    "routes.loadingWeather": "Cargando tiempo...",
    "routes.from": "Desde",
    "routes.to": "Hasta",
    "routes.nogo": "NoGo",
    "routes.draught": "Calado",
    "routes.route": "Ruta",
    "routes.change": "cambiar",
    "routes.clear": "Limpiar",
    "routes.searching": "Buscando...",
    "routes.showHazards": "Mostrar peligros",
    "routes.showOnlyDangers": "Mostrar solo tramos peligrosos",
    "routes.detailed": "Detallado",
    "routes.general": "General",
    "routes.filtered": "Filtrado",
    "routes.connect": "Conectar",
    "routes.cancel": "Cancelar",
    "routesettings.nogo": "NoGo (m)",
    "route.dateToFar":
      "La fecha está demasiado lejana para obtener un pronóstico de mareas. Ingrese una nueva fecha para obtener un pronóstico actualizado.",
    "route.loading": "Cargando...",
    "route.submit": "Enviar",
    "route.update": "Actualizar",
    "route.calculatingPrice": "Calculando precio...",
    "route.ovr": "RSN",
    "route.gnr": "GNR",
    "route.cst": "CST",
    "route.apr": "APR",
    "route.hrb": "PRT",
    "route.brg": "ATR",
    "route.less30": "menos de 30 días",
    "route.infolio": "en folio",
    "route.selected": "seleccionado",
    "route.unselected": "no seleccionado",
    "route.multiple": "múltiple",
    "route.approve": "Aprobar",
    "route.cancel": "Cancelar",
    "route.pleaseWait": "Por favor espere...",
    "route.downloadpdf": "Descargar PDF",
    "route.import": "Importar",
    "route.order": "Pedido",
    "route.routeName": "Nombre de la ruta",
    "route.change": "cambiar",
    "route.nogo": "NoGo:",
    "route.draught": "Calado",
    "route.length": "Eslora",
    "route.width": "Manga",
    "route.height": "Altura",
    "route.displacement": "Desplazamiento",
    "route.checkRouteFirst": "Primero debe verificar la seguridad de la ruta.",
    "route.contractExpired":
      "El período de servicio bajo su contrato ha expirado para el buque. Por favor, celebre un nuevo contrato.",
    "route.noContract":
      "Este buque no está bajo contrato de servicio. Puede celebrar un contrato para el servicio de este buque.",
    "route.loadingCatalog": "Cargando catálogo...",
    "route.loadingProducts": "Cargando productos por ruta...",
    "route.Loading": "Cargando...",
    "route.loadingShips": "Cargando barcos...",
    "route.loadingAgreements": "Cargando acuerdos...",
    "route.safetyCalculation": "Calculando ruta/seguridad...",
    "route.calculation": "Calculando ruta...",
    "route.loadZones": "Cargar zonas",
    "route.loadPaths": "Cargar rutas",
    "route.loadRTZ": "Cargar RTZ",
    "route.saveRTZ": "Guardar RTZ",
    "route.search": "BUSCAR",
    "route.settings": "CONFIGURACIÓN",
    "route.mapInfo": "INFORMACIÓN DEL MAPA",
    "route.addShip": "Añadir un barco a la cuenta, antes de trazar la ruta",
    "route.calculatedTime": "Ruta calculada en:",
    "route.seconds": " segundos",
    "route.totalWP": "Total de waypoints",
    "route.totalSegments": "Total segments",
    "route.totalLength": "Longitud total",
    "route.estimatedLength": "Longitud estimada",
    "route.startTime": "Hora de inicio",
    "route.ETA": "ETA",
    "route.latlon": "Lat/Lon",
    "route.hazards": "Peligros",
    "route.speed": "Velocidad",
    "route.saveRoute": "Guardar ruta",
    "route.enterRouteName": "Ingrese el nombre de la ruta",
    "route.typeToSearch": "Escriba para buscar",
    "route.name": "Nombre",
    "route.start": "Inicio",
    "route.finish": "Fin",
    "route.autoRouting": "Enrutamiento automático",
    "route.general": "general",
    "route.detailed": "detallado",
    "route.m": "m",
    "route.updateGeneral": "Update General Route",
    "settings.nogo": "NoGo (m)",
    "settings.reset": "Restablecer configuración",
    "settings.draught": "Calado (m)",
    "settings.height": "Altura (m)",
    "settings.length": "Eslora (m)",
    "settings.width": "Manga (m)",
    "settings.displacement": "Desplazamiento (t)",
    "settings.radius": "Radio (m)",
    "settings.xtl": "XTE.L (m)",
    "settings.xtr": "XTE.R (m)",
    "settings.speed": "Velocidad (nudos)",
    "settings.trackRatio": "Proporción de seguimiento",
    "settings.shallowRatio": "Proporción de aguas poco profundas",
    "settings.avoidShallowStrength": "Fuerza para evitar aguas poco profundas",
    "settings.avoidDistance": "Distancia de evitación (m)",
    "settings.refineCoeff": "Coeficiente de refinamiento",
    "settings.startDate": "Fecha de inicio",
    "settings.startTime": "Hora de inicio",
    "settings.allowSuez": "Permitir canal de Suez",
    "settings.allowPanama": "Permitir canal de Panamá",
    "settings.allowBering": "Permitir estrecho de Bering",
    "settings.allowRivers": "Permitir ríos",
    "settings.recommendedTracks": "Rutas recomendadas",
    "settings.generalRoutes": "Solo rutas generales",
    "settings.graphRouteScoreFactor": "Graph weight",
    "settings.landAroundScoreFactor": "Land contour weight",
    "settings.linkHeuristicFactor": "Link heuristic factor",
    "settings.waterScoreFactor": "Graph water weight",
    "settings.previewLandContour": "Preview land contour",
    "settings.graphDiag": "Show graph diagnostics",
    "settings.nearestPointsNumber": "Graph points",
    "settings.tiles": "Tiles",
    "msg.agreementWarning": "Advertencia de acuerdo",
    "msg.routeValidation": "Route validation",
    "editor.loadingWarning":
      "La carga reemplazará todos los datos existentes. ¿Continuar?",
    "editor.editor": "EDITOR",
    "editor.load": "Cargar",
    "editor.clear": "Limpiar",
    "editor.export": "Exportar líneas seleccionadas",
    "connect.connectPanel": "PANEL DE CONEXIÓN",
    "connect.getPosition": "Obtener posición",
    "connect.getStatus": "Obtener estado",
    "connect.getRoute": "Obtener ruta",
    "connect.getFolio": "Obtener folio",
    "connect.requesting": "Solicitando...",
    "logbook.logbook": "DIARIO DE NAVEGACIÓN",
    "logbook.images": "Imágenes",
    "logbook.audio": "Audio",
    "logbook.selectImages": "Seleccionar imágenes...",
    "deliveries.deliveries": "ENTREGAS",
    "deliveries.content": "Contenido",
    "deliveries.type": "Tipo",
    "deliveries.date": "Fecha",
    "deliveries.size": "Tamaño",
    "deliveries.bytes": "bytes",
    "deliveries.kib": "KiB",
    "deliveries.mib": "MiB",
    "deliveries.gib": "GiB",
    "deliveries.tib": "TiB",
    "deliveries.pib": "PiB",
    "deliveries.eib": "EiB",
    "deliveries.zib": "ZiB",
    "deliveries.yib": "YiB",
    "deliveries.fullSet": "juego completo",
    "deliveries.regularUpdate": "actualización regular",
    "deliveries.order": "pedido",
    "transactions.transaction": "TRANSACCIONES",
    "transactions.request": "solicitud",
    "transactions.toPay": "por pagar",
    "transactions.processing": "procesando",
    "transactions.complete": "completo",
    "transactions.error": "error",
    "transactions.notFound": "no encontrado",
    "transactions.pending": "pendiente",
    "transactions.downloading": "descargando cartas",
    "transactions.cancel": "cancelado",
    "transactions.status": "Estado",
    "transactions.id": "ID",
    "transactions.date": "Fecha",
    "transactions.customer": "Cliente",
    "transactions.ship": "Barco",
    "transactions.content": "Contenido",
    "transactions.payment": "Pago",
    "transactions.price": "Precio",
    "transactions.updated": "Actualizado",
    "transactions.user": "Usuario",
    "order.validTill": "Válido hasta",
    "order.band": "Banda",
    "order.name": "Nombre",
    "order.price": "Precio",
    "order.ai": "AI",
    "order.till": "Hasta",
    "bands.overview": "resumen",
    "bands.general": "general",
    "bands.coastal": "costero",
    "bands.approach": "aproximación",
    "bands.harbour": "puerto",
    "bands.berthing": "atraque",
    "order.period": "período",
    "order.totalPrice": "Precio total",
    "order.items": "artículos",
    "order.months": "meses",
    "order.agreement": "Acuerdo",
    "order.ship": "Barco",
    "order.selected": "Seleccionado",
    "order.id": "ID",
    "order.importList": "Importar lista de celdas",
    "order.pastList":
      "Pegue nombres de celdas separados por comas o nuevas líneas...",
    "order.availableAVCS": "AVCS disponibles",
    "order.availableADP": "ADP disponibles",
    "order.availableENP": "eNP disponibles",
    "order.availableENC": "ENC disponibles",
    "order.timeUTC": "Hora UTC",
    "order.chartD": "Carta.D m",
    "order.safeRoute": "Ruta segura",
    "order.safeD": "Seguro.D m",
    "order.ukc": "UKC m",
    "order.openWaters": "Aguas abiertas",
    "order.draft": "Calado",
    "order.speed": "Velocidad nudos",
    "order.disp": "Despl. t",
    "order.policy": "Política m",
    "order.swuat": "Squat m",
    "order.tide": "Marea m",
    "order.zoc": "ZOC m",
    "order.yes": "SÍ",
    "order.no": "NO",
    "order.length": "Eslora",
    "order.width": "Manga",
    "order.displacement": "Desplazamiento",
    "order.m": "m",
    "order.t": "T",
    "order.eta": "ETA",
    "order.wind": "Viento",
    "order.direction": "Dirección",
    "order.ms": "m/s",
    "order.routeStartTime": "Hora de inicio de la ruta:",
    "map.editNoGoZones": "Editar zonas NoGo",
    "map.exitEditing": "Salir de la edición",
    "map.makeNavRoute": "Calculate",
    "map.clearRoute": "Limpiar ruta",
    "map.clearRoutePrompt": "Limpiar ruta?",
    "map.clearRouteHint": "Limpiar toda la ruta y waypoints",
    "map.checkPointSafety": "Verificar seguridad del punto",
    "map.checkPointSafetyHint": "Verificar la seguridad del punto",
    "map.checkRouteSafety": "Verificar seguridad de la ruta",
    "map.checkRouteSafetyHint": "Verificar la seguridad de la ruta",
    "map.recalculateRoute": "Recalcular ruta",
    "map.recalculateRouteHint": "Recalcular seguridad para la ruta",
    "map.recalculatePoint": "Recalcular punto",
    "map.recalculatePointHint": "Recalcular el punto",
    "map.movePoint": "mover punto",
    "map.movePointLeft": "mover punto a la izquierda",
    "map.movePointUp": "mover punto hacia arriba",
    "map.movePointDown": "mover punto hacia abajo",
    "map.movePointRight": "mover punto a la derecha",
    "map.moveLegLeft": "mover tramo a la izquierda",
    "map.moveLegUp": "mover tramo hacia arriba",
    "map.moveLegDown": "mover tramo hacia abajo",
    "map.moveLegRight": "mover tramo a la derecha",
    "map.removePoint": "eliminar punto",
    "map.start": "Inicio",
    "map.add": "Añadir",
    "map.insert": "Insertar",
    "map.finish": "Fin",
    "map.move": "Mover",
    "map.nogo": "NoGo:",
    "map.m": "m",
    "fleet.fleet": "Flota",
    "fleet.online": "En línea",
    "fleet.offline": "Fuera de línea",
    "fleet.alarm": "Alarma",
    "fleet.imo": "IMO",
    "fleet.edit": "editar barco",
    "fleet.upn": "UPN",
    "fleet.folio": "Folio",
    "fleet.updates": "Actualizaciones",
    "fleet.available": "Disponible",
    "fleet.orders": "pedidos",
    "fleet.addOrder": "añadir un pedido",
    "fleet.latestReport": "Último informe",
    "fleet.viewReports": "ver informes",
    "fleet.status": "Estado",
    "fleet.noMapsForRoute": "No hay suficientes mapas para la ruta",
    "fleet.pressToAddShip": "No se encontraron barcos",
    "fleet.noShipsFound": "Presione para añadir un barco",
    "fleet.addShip": "Añadir",
    "fleet.addECDIS": "Añadir ECDIS",
    "fleet.addByQR": "Añadir por código QR",
    "fleet.addManually": "Añadir manualmente",
    "fleet.account": "Cuenta",
    "fleet.latest": "Último",
    "fleet.more": "más",
    "fleet.noOrders": "sin pedidos",
    "fleet.deliveries": "entregas",
    "fleet.deviceid": "ID del dispositivo",
    "general.autoband": "Banda automática",
    "general.overview": "Resumen",
    "general.distributors": "Distribuidores",
    "general.geoPhone": "GeoPhone Group International OY",
    "general.distributorsList":
      "A continuación encontrará la lista de nuestros distribuidores certificados.",
    "general.loadingFleetData": "Cargando datos de la flota",
    "general.noPosition": "sin posición",
    "general.dataProvider": "Proveedor de datos",
    "general.latLon": "Lat/Lon",
    "general.hazards": "Peligros",
    "general.speed": "Velocidad",
    "general.eta": "ETA",
    "general.length": "Longitud",
    "general.startTime": "Hora de inicio:",
    "general.totalLength": "Longitud total:",
    "general.checkRouteSafety": "Verificar seguridad de la ruta",
    "general.loading": "Cargando...",
    "general.loadingEllipsis": "cargando...",
    "general.pleaseSelectPng":
      "Por favor, seleccione un archivo de imagen PNG.",
    "general.uploadImage": "Subir imagen",
    "distributors.title": "Distribuidores",
    "distributors.subtitle": "Seleccione su distribuidor certificado",
    "distributors.agreementStatus": "Estado del Acuerdo",
    "distributors.shipInfo": "Información del Barco",
    "distributors.hasAgreement": "Este barco es atendido bajo acuerdo",
    "distributors.agreementDetails": "Detalles del Acuerdo",
    "distributors.noAgreement": "Este barco no está conectado a ningún acuerdo",
    "distributors.needAgreement":
      "Para acceder a los servicios del distribuidor, necesita conectarse a un acuerdo",
    "distributors.contactSupport": "Contacte al soporte para asistencia",
    "distributors.selectDistributor":
      "Por favor, seleccione un distribuidor a continuación:",
    "distributors.subscriptionOptions": "Opciones de Suscripción",
    "distributors.subscribe": "Suscribirse",
    "distributors.contactEmail": "Contactar por Email",
    "distributors.location": "Ubicación",
    "distributors.services": "Servicios",
    "distributors.support": "Soporte",
    "distributors.loading": "Cargando distribuidores...",
    "distributors.noDistributors": "No hay distribuidores disponibles",
    "distributors.error": "Error cargando distribuidores",
    "distributors.retry": "Reintentar",
    "distributors.back": "Volver al Principal",
    "distributors.selectShipFirst": "Por favor, seleccione un barco primero",
    "distributors.agreementId": "ID del Acuerdo",
    "distributors.agreementName": "Nombre del Acuerdo",
    "distributors.shipName": "Nombre del Barco",
    "distributors.dataProvider": "Proveedor de Datos",
  },
  tr: {
    "menu.fleet": "Filо",
    "menu.maps": "Haritalar",
    "menu.ships": "Gemiler",
    "menu.transactions": "İşlemler",
    "menu.deliveries": "Teslimatlar",
    "menu.logbook": "Seyir Defteri",
    "menu.connect": "Bağlan",
    "menu.editor": "Düzenleyici",
    "menu.help": "Yardım",
    "tabs.ports": "Limanlar",
    "tabs.routes": "Rotalar",
    "tabs.settings": "Ayarlar",
    "tabs.files": "Dosyalar",
    "tabs.wp": "Yol Noktası",
    "tabs.generalRoute": "General",
    "tabs.ukc": "UKC",
    "tabs.pplan": "Geçiş Planı",
    "tabs.weather": "Hava Durumu",
    "tabs.folio": "Folyo",
    "tabs.order": "Sipariş",
    "btn.ok": "Tamam",
    "btn.cancel": "İptal",
    "btn.close": "Kapat",
    "btn.clear": "Temizle",
    "btn.submit": "Gönder",
    "btn.save": "Kaydet",
    "btn.add": "Ekle",
    "btn.delete": "Sil",
    "btn.edit": "Düzenle",
    "btn.search": "Ara",
    "text.internetIsLost":
      "İnternet bağlantınız kesildi. Site kısıtlı modda çalışıyor.",
    "menu.profile": "Profil",
    "menu.signOut": "Çıkış Yap",
    "trans.delivery": "TESLİMAT",
    "trans.afterClickOrderDownloading":
      "Butona tıkladıktan sonra sipariş indirilmeye başlayacaktır. İndirme işleminin birkaç dakika sürebileceğini lütfen unutmayın.",
    "trans.items": "ÖGELER",
    "trans.shipName": "Gemi adı:",
    "trans.paymentBy": "Ödeme şekli:",
    "trans.agreement": "anlaşma",
    "trans.created": "Oluşturuldu",
    "trans.paid": "Ödendi",
    "trans.cells": "Hücreler",
    "trans.copyENCids": "ENC ID'lerini panoya kopyala",
    "trans.orderUpdates": "SİPARİŞ GÜNCELLEMELERİ",
    "trans.loadingShips": "Gemiler yükleniyor...",
    "trans.loadingAgreement": "Anlaşmalar yükleniyor...",
    "trans.orderOutdated": "Sipariş güncel değil",
    "trans.checkUpdates": "Güncellemeleri kontrol et",
    "trans.loading": "Yükleniyor ...",
    "trans.edit": "Düzenle",
    "trans.request": "Talep",
    "trans.topay": "Ödenecek",
    "trans.cancel": "İptal",
    "login.login": "Giriş",
    "login.logInToAccount": "Hesabınıza Giriş Yapın",
    "login.registration": "Kayıt",
    "login.regSuccess":
      "Kayıt başarılı. Kayıt olduğunuz için teşekkür ederiz. Lütfen şifre için e-postanızı kontrol edin.",
    "login.regNotSuccess": "Kayıt başarısız. Muhtemelen e-posta zaten kayıtlı.",
    "login.submit": "Gönder",
    "login.howToGetStarted": "Nasıl Başlanır",
    "login.submitYourEmail":
      "Lütfen geçerli e-postanızı gönderin ve şifreyi alın. Şifreyi girerek kayıt tamamlanır.",
    "login.howToPurchase": "ENC'ler Nasıl Satın Alınır",
    "login.enterCredentials":
      "Kimlik bilgilerinizi girerek etkinleştirilmiş mobil cihazınızı veya ECDIS hesabınızı seçin ve elektronik kataloğa erişin.",
    "login.youMayPurchase":
      "Norveç veya Estonya gibi hazır harita foliolarını satın alabilirsiniz, ABD haritaları ücretsizdir. PRIMAR durumunda, WEB haritasından veya Harita Artırıcı işlevleriyle istediğiniz ENC'leri seçip ödeme işlemini gerçekleştirmelisiniz. Sipariş geçmişi ve ödeme kayıtları saklanır.",
    "login.systemAutoPrevents":
      "Sistem, haritaların çift satın alınmasını otomatik olarak önler ve grafik düzenleyici tarafından düzeltilebilen otomatik olarak hesaplanan rota ile harita seçimine yardımcı olabilir.",
    "login.news": "Haberler",
    "mobile.rotatePhone":
      "Telefonunuzu yatay konuma çevirin ve Giriş butonuna basın",
    "mobile.login": "Giriş",
    "payment.returnToOrders": "Siparişlerinize dönün",
    "reg.registration": "Kayıt",
    "reg.regSuccess":
      "Kayıt başarılı. Kayıt olduğunuz için teşekkür ederiz. Lütfen şifre için e-postanızı kontrol edin.",
    "reg.regNotSuccess": "Kayıt başarısız. Muhtemelen e-posta zaten kayıtlı.",
    "reg.submit": "Gönder",
    "reg.incorrectPassword": "Hatalı şifre. Lütfen tekrar deneyin.",
    "ships.edit": "Düzenle",
    "ships.details": "DETAYLAR",
    "ships.deviceId": "Cihaz ID:",
    "ships.email": "E-posta:",
    "ships.shipName": "Gemi adı:",
    "ships.category": "Kategori:",
    "ships.type": "Tip:",
    "ships.brand": "ECDIS marka:",
    "ships.imo": "IMO:",
    "ships.callsign": "Çağrı işareti:",
    "ships.permit": "İzin:",
    "ships.license": "Lisans:",
    "ships.licenseType": "Lisans türü:",
    "ships.licenseValid": "Lisans geçerli:",
    "ships.emails": "Bildirim e-postaları:",
    "ships.delveryEmails": "Teslimat e-postası:",
    "ships.charts": "Haritalar:",
    "ships.expired": "süresi doldu",
    "ships.loadingInstllations": "Kurulumlar yükleniyor...",
    "ships.noInfo":
      "Gemi için bilgi bulunamadı. Gemi bilgilerini okumak için ECDIS'ten QR kodunu tarayın",
    "ships.qrcode": "QR Kod",
    "ships.report": "Rapor",
    "ships.onmap": "Haritada",
    "ships.view": "Görüntüle",
    "ships.clear": "Temizle",
    "ships.byqrcode": "QR kod ile",
    "ships.manually": "Manuel",
    "ships.selected": "Seçildi",
    "ships.notSelected": "Seçilmedi",
    "ship.addShip": "Gemi ekle",
    "ship.shipName": "Gemi adı",
    "ship.edit": "Düzenle",
    "ship.report": "Rapor",
    "ship.viewEdit": "Gemi görüntüle/düzenle",
    "ship.selectProvider": "Veri sağlayıcı seç",
    "ship.id": "ID",
    "ship.band": "Bant",
    "ship.ordered": "Sipariş edildi",
    "ship.daysValid": "Geçerli gün sayısı",
    "ships.mmsi": "MMSI:",
    "ships.callSign": "Çağrı İşareti:",
    "ships.country": "Ülke:",
    "ships.length": "Uzunluk:",
    "ships.width": "Genişlik:",
    "ships.height": "Yükseklik:",
    "ships.draught": "Su çekimi:",
    "ships.shipCategory": "Gemi kategorisi:",
    "ships.os": "ECIDS İşletim Sistemi:",
    "ships.permit1": "Yedek izin 1:",
    "ships.permit2": "Yedek izin 2:",
    "payment.placingOrder": "Siparişiniz oluşturuluyor...",
    "payment.clickToPayment": "Ödeme sayfasına gitmek için tıklayın",
    "logbook.loadingShips": "Gemiler yükleniyor...",
    "logbook.loadingAgreements": "Anlaşmalar yükleniyor...",
    "logbook.addReport": "Rapor Ekle",
    "logbook.lat": "LAT",
    "logbook.lon": "LON",
    "logbook.hdg": "HDG",
    "logbook.sog": "SOG",
    "logbook.message": "Mesaj",
    "logbook.cancel": "İptal",
    "logbook.saveReport": "Raporu Kaydet",
    "logbook.link": "bağlantı",
    "logbook.ecdis": "ecdis",
    "editor.cancel": "İptal",
    "editor.save": "Kaydet",
    "ecdis.ecdis": "ECDIS",
    "ecdis.save": "Kaydet",
    "ecdis.add": "Ekle",
    "ecdis.nowYouCan": "Artık şu sayfayı ziyaret edebilirsiniz:",
    "ecdis.andSelect":
      "sekmesini seçip harita satın almak için ECDIS cihazını seçin.",
    "ecdis.mydevices": "Cihazlarım",
    "connect.loadingShips": "Gemiler yükleniyor...",
    "connect.loadingAgreements": "Anlaşmalar yükleniyor...",
    "agreement.statusOwner": "Durum: sahip",
    "agreement.agrements": "Anlaşmalar",
    "agreement.loadings": "Yükleniyor...",
    "agreement.noAgreements": "ANLAŞMA YOK",
    "deliveries.loadingShips": "Gemiler yükleniyor...",
    "deliveries.loadingAgreements": "Anlaşmalar yükleniyor...",
    "deliveries.checkUpdates": "Güncellemeleri kontrol et",
    "deliveries.loading": "Yükleniyor...",
    "deliveries.download": "İndir",
    "routes.trafficSepZone": "Trafik ayırma bölgesi",
    "routes.inshoreTrafZone": "Kıyı trafik bölgesi",
    "routes.restArea": "Kısıtlı bölge",
    "routes.cautionArea": "Dikkat bölgesi",
    "routes.offshoreProdArea": "Açık deniz üretim alanı",
    "routes.avoidedArea": "Kaçınılması gereken bölgeler",
    "routes.militaryArea": "Askeri tatbikat alanı",
    "routes.seaplaneArea": "Deniz uçağı iniş alanı",
    "routes.submarineLine": "Denizaltı geçiş hattı",
    "routes.anchorageArea": "Demirleme bölgesi",
    "routes.marineFarm": "Deniz çiftliği/su ürünleri yetiştiriciliği",
    "routes.pssa": "ÖHDA",
    "routes.showWind": "Rüzgarı göster",
    "routes.showTemp": "Sıcaklığı göster",
    "routes.selectDateTime": "Önce tarih/saat seçin",
    "routes.weatherNotAvailable":
      "Rota için hava durumu mevcut değil, yeniden hesaplayın",
    "routes.weatherNotAvailableForRoute": "Rota için hava durumu mevcut değil",
    "routes.loadingWeather": "Hava durumu yükleniyor...",
    "routes.from": "Başlangıç",
    "routes.to": "Varış",
    "routes.nogo": "NoGo",
    "routes.draught": "Su çekimi",
    "routes.route": "Rota",
    "routes.change": "değiştir",
    "routes.clear": "Temizle",
    "routes.searching": "Aranıyor...",
    "routes.showHazards": "Tehlikeleri göster",
    "routes.showOnlyDangers": "Sadece tehlikeli bacakları göster",
    "routes.detailed": "Detaylı",
    "routes.general": "Genel",
    "routes.filtered": "Filtrelenmiş",
    "routes.connect": "Bağlan",
    "routes.cancel": "İptal",
    "routesettings.nogo": "NoGo (m)",
    "route.dateToFar":
      "Tarih, gelgit tahmini almak için çok uzak. Güncel bir tahmin almak için yeni bir tarih girin.",
    "route.loading": "Yükleniyor...",
    "route.submit": "Gönder",
    "route.update": "Güncelle",
    "route.calculatingPrice": "Fiyat hesaplanıyor...",
    "route.ovr": "GB",
    "route.gnr": "GNL",
    "route.cst": "Kıyı",
    "route.apr": "YALM",
    "route.hrb": "LMN",
    "route.brg": "YASM",
    "route.less30": "30 günden az",
    "route.infolio": "folio içinde",
    "route.selected": "seçildi",
    "route.unselected": "seçilmedi",
    "route.multiple": "çoklu",
    "route.approve": "Onayla",
    "route.cancel": "İptal",
    "route.pleaseWait": "Lütfen bekleyin...",
    "route.downloadpdf": "PDF İndir",
    "route.import": "İçe Aktar",
    "route.order": "Sipariş",
    "route.routeName": "Rota adı",
    "route.change": "değiştir",
    "route.nogo": "NoGo:",
    "route.draught": "Su çekimi",
    "route.length": "Uzunluk",
    "route.width": "Genişlik",
    "route.height": "Yükseklik",
    "route.displacement": "Deplasman",
    "route.checkRouteFirst":
      "Önce rotanın güvenliğini kontrol etmeniz gerekiyor.",
    "route.contractExpired":
      "Gemi için sözleşme kapsamındaki hizmet süreniz doldu. Lütfen yeni bir sözleşme yapın.",
    "route.noContract":
      "Bu gemi sözleşme kapsamında servis edilmiyor. Bu gemi için bir servis sözleşmesi yapabilirsiniz.",
    "route.loadingCatalog": "Katalog yükleniyor...",
    "route.loadingProducts": "Rota ürünleri yükleniyor...",
    "route.Loading": "Yükleniyor...",
    "route.loadingShips": "Gemiler yükleniyor...",
    "route.loadingAgreements": "Anlaşmalar yükleniyor...",
    "route.safetyCalculation": "Rota/Güvenlik hesaplanıyor...",
    "route.calculation": "Rota hesaplanıyor...",
    "route.loadZones": "Bölgeleri Yükle",
    "route.loadPaths": "Yolları Yükle",
    "route.loadRTZ": "RTZ Yükle",
    "route.saveRTZ": "RTZ Kaydet",
    "route.search": "ARA",
    "route.settings": "AYARLAR",
    "route.mapInfo": "HARİTA BİLGİSİ",
    "route.addShip": "Rota oluşturmadan önce hesaba gemi ekleyin",
    "route.calculatedTime": "Rota hesaplama süresi:",
    "route.seconds": " saniye",
    "route.totalWP": "Toplam yol noktası",
    "route.totalSegments": "Toplam segment",
    "route.totalLength": "Toplam uzunluk",
    "route.estimatedLength": "Tahmini uzunluk",
    "route.startTime": "Başlangıç zamanı",
    "route.ETA": "ETA",
    "route.latlon": "En/Boy",
    "route.hazards": "Tehlikeler",
    "route.speed": "Hız",
    "route.saveRoute": "Rotayı kaydet",
    "route.enterRouteName": "Rota adı girin",
    "route.typeToSearch": "Aramak için yazın",
    "route.name": "Ad",
    "route.start": "Başlangıç",
    "route.finish": "Bitiş",
    "route.autoRouting": "Otomatik rota oluşturma",
    "route.general": "genel",
    "route.detailed": "detaylı",
    "route.m": "m",
    "route.updateGeneral": "Update General Route",
    "settings.nogo": "NoGo (m)",
    "settings.reset": "Ayarları Sıfırla",
    "settings.draught": "Su çekimi (m)",
    "settings.height": "Yükseklik (m)",
    "settings.length": "Uzunluk (m)",
    "settings.width": "Genişlik (m)",
    "settings.displacement": "Deplasman (t)",
    "settings.radius": "Yarıçap (m)",
    "settings.xtl": "XTE.L (m)",
    "settings.xtr": "XTE.R (m)",
    "settings.speed": "Hız (knot)",
    "settings.trackRatio": "İz oranı",
    "settings.shallowRatio": "Sığ su oranı",
    "settings.avoidShallowStrength": "Sığ sudan kaçınma gücü",
    "settings.avoidDistance": "Kaçınma mesafesi (m)",
    "settings.refineCoeff": "İyileştirme katsayısı",
    "settings.startDate": "Başlangıç tarihi",
    "settings.startTime": "Başlangıç saati",
    "settings.allowSuez": "Süveyş kanalına izin ver",
    "settings.allowPanama": "Panama kanalına izin ver",
    "settings.allowBering": "Bering boğazına izin ver",
    "settings.allowRivers": "Nehirlere izin ver",
    "settings.recommendedTracks": "Önerilen rotalar",
    "settings.generalRoutes": "Sadece genel rotalar",
    "settings.graphRouteScoreFactor": "Graph weight",
    "settings.landAroundScoreFactor": "Land contour weight",
    "settings.linkHeuristicFactor": "Link heuristic factor",
    "settings.waterScoreFactor": "Graph water weight",
    "settings.previewLandContour": "Preview land contour",
    "settings.graphDiag": "Show graph diagnostics",
    "settings.nearestPointsNumber": "Graph points",
    "settings.tiles": "Döşemeler",
    "msg.agreementWarning": "Anlaşma uyarısı",
    "msg.routeValidation": "Route validation",
    "editor.loadingWarning":
      "Yükleme mevcut tüm verilerin üzerine yazacak. Devam etmek istiyor musunuz?",
    "editor.editor": "DÜZENLEYİCİ",
    "editor.load": "Yükle",
    "editor.clear": "Temizle",
    "editor.export": "Seçili Hatları Dışa Aktar",
    "connect.connectPanel": "BAĞLANTI PANELİ",
    "connect.getPosition": "Pozisyon al",
    "connect.getStatus": "Durum al",
    "connect.getRoute": "Rota al",
    "connect.getFolio": "Folio al",
    "connect.requesting": "Talep ediliyor...",
    "logbook.logbook": "SEYİR DEFTERİ",
    "logbook.images": "Görüntüler",
    "logbook.audio": "Ses",
    "logbook.selectImages": "Görüntüleri seç...",
    "deliveries.deliveries": "TESLİMATLAR",
    "deliveries.content": "İçerik",
    "deliveries.type": "Tür",
    "deliveries.date": "Tarih",
    "deliveries.size": "Boyut",
    "deliveries.bytes": "bayt",
    "deliveries.kib": "KiB",
    "deliveries.mib": "MiB",
    "deliveries.gib": "GiB",
    "deliveries.tib": "TiB",
    "deliveries.pib": "PiB",
    "deliveries.eib": "EiB",
    "deliveries.zib": "ZiB",
    "deliveries.yib": "YiB",
    "deliveries.fullSet": "tam set",
    "deliveries.regularUpdate": "düzenli güncelleme",
    "deliveries.order": "sipariş",
    "transactions.transaction": "İŞLEMLER",
    "transactions.request": "talep",
    "transactions.toPay": "ödenmemiş",
    "transactions.processing": "işleniyor",
    "transactions.complete": "tamamlandı",
    "transactions.error": "hata",
    "transactions.notFound": "bulunamadı",
    "transactions.pending": "beklemede",
    "transactions.downloading": "haritalar indiriliyor",
    "transactions.cancel": "iptal edildi",
    "transactions.status": "Durum",
    "transactions.id": "ID",
    "transactions.date": "Tarih",
    "transactions.customer": "Müşteri",
    "transactions.ship": "Gemi",
    "transactions.content": "İçerik",
    "transactions.payment": "Ödeme",
    "transactions.price": "Fiyat",
    "transactions.updated": "Güncellendi",
    "transactions.user": "Kullanıcı",
    "order.validTill": "Geçerlilik tarihi",
    "order.band": "Bant",
    "order.name": "Ad",
    "order.price": "Fiyat",
    "order.ai": "AI",
    "order.till": "Kadar",
    "bands.overview": "genel bakış",
    "bands.general": "genel",
    "bands.coastal": "kıyı",
    "bands.approach": "yaklaşım",
    "bands.harbour": "liman",
    "bands.berthing": "yanaşma",
    "order.period": "dönem",
    "order.totalPrice": "Toplam fiyat",
    "order.items": "öğeler",
    "order.months": "aylar",
    "order.agreement": "Anlaşma",
    "order.ship": "Gemi",
    "order.selected": "Seçildi",
    "order.id": "ID",
    "order.importList": "Hücre listesini içe aktar",
    "order.pastList":
      "Virgül veya yeni satırla ayrılmış hücre adlarını yapıştırın...",
    "order.availableAVCS": "Mevcut AVCS",
    "order.availableADP": "Mevcut ADP",
    "order.availableENP": "Mevcut eNP",
    "order.availableENC": "Mevcut ENC",
    "order.timeUTC": "UTC Zamanı",
    "order.chartD": "Chart.D m",
    "order.safeRoute": "Güvenli rota",
    "order.safeD": "Safe.D m",
    "order.ukc": "UKC m",
    "order.openWaters": "Açık sular",
    "order.draft": "Draft",
    "order.speed": "Hız kn",
    "order.disp": "Disp. t",
    "order.policy": "Politika m",
    "order.swuat": "Squat m",
    "order.tide": "Gelgit m",
    "order.zoc": "ZOC m",
    "order.yes": "EVET",
    "order.no": "HAYIR",
    "order.length": "Uzunluk",
    "order.width": "Genişlik",
    "order.displacement": "Deplasman",
    "order.m": "m",
    "order.t": "T",
    "order.eta": "ETA",
    "order.wind": "Rüzgar",
    "order.direction": "Yön",
    "order.ms": "m/s",
    "order.routeStartTime": "Rota başlangıç zamanı:",
    "map.editNoGoZones": "NoGo bölgelerini düzenle",
    "map.exitEditing": "Düzenlemeden çık",
    "map.makeNavRoute": "Yeniden hesapla",
    "map.clearRoute": "Rotayı temizle",
    "map.clearRoutePrompt": "Rotayı temizle?",
    "map.clearRouteHint": "Tüm rotayı ve yol noktalarını temizle",
    "map.checkPointSafety": "Nokta güvenliğini kontrol et",
    "map.checkPointSafetyHint": "Nokta güvenliğini kontrol et",
    "map.checkRouteSafety": "Rota güvenliğini kontrol et",
    "map.checkRouteSafetyHint": "Rota güvenliğini kontrol et",
    "map.recalculateRoute": "Rotayı yeniden hesapla",
    "map.recalculateRouteHint": "Rota güvenliğini yeniden hesapla",
    "map.recalculatePoint": "Noktayı yeniden hesapla",
    "map.recalculatePointHint": "Noktayı yeniden hesapla",
    "map.movePoint": "noktayı taşı",
    "map.movePointLeft": "noktayı sola taşı",
    "map.movePointUp": "noktayı yukarı taşı",
    "map.movePointDown": "noktayı aşağı taşı",
    "map.movePointRight": "noktayı sağa taşı",
    "map.moveLegLeft": "bacak sola taşı",
    "map.moveLegUp": "bacak yukarı taşı",
    "map.moveLegDown": "bacak aşağı taşı",
    "map.moveLegRight": "bacak sağa taşı",
    "map.removePoint": "noktayı kaldır",
    "map.start": "Başlangıç",
    "map.add": "Ekle",
    "map.insert": "Ekle",
    "map.finish": "Bitiş",
    "map.move": "Taşı",
    "map.nogo": "NoGo:",
    "map.m": "m",
    "fleet.fleet": "Filo",
    "fleet.online": "Çevrimiçi",
    "fleet.offline": "Çevrimdışı",
    "fleet.alarm": "Alarm",
    "fleet.imo": "IMO",
    "fleet.edit": "gemiyi düzenle",
    "fleet.upn": "UPN",
    "fleet.folio": "Folio",
    "fleet.updates": "Güncellemeler",
    "fleet.available": "Mevcut",
    "fleet.orders": "siparişler",
    "fleet.addOrder": "sipariş ekle",
    "fleet.latestReport": "Son Rapor",
    "fleet.viewReports": "raporları görüntüle",
    "fleet.status": "Durum",
    "fleet.noMapsForRoute": "Rota için yeterli harita yok",
    "fleet.pressToAddShip": "Gemi bulunamadı",
    "fleet.noShipsFound": "Gemi eklemek için basın",
    "fleet.addShip": "Ekle",
    "fleet.addECDIS": "ECDIS Ekle",
    "fleet.addByQR": "QR kodu ile ekle",
    "fleet.addManually": "Manuel olarak ekle",
    "fleet.account": "Hesap",
    "fleet.latest": "Son",
    "fleet.more": "daha fazla",
    "fleet.noOrders": "sipariş yok",
    "fleet.deliveries": "teslimatlar",
    "fleet.deviceid": "Cihaz Kimliği",
    "general.autoband": "Otomatik bant",
    "general.overview": "Genel bakış",
    "general.distributors": "Distribütörler",
    "general.geoPhone": "GeoPhone Group International OY",
    "general.distributorsList":
      "Sertifikalı distribütörlerimizin listesini aşağıda bulabilirsiniz.",
    "general.loadingFleetData": "Filo verileri yükleniyor",
    "general.noPosition": "konum yok",
    "general.dataProvider": "Veri sağlayıcısı",
    "general.latLon": "Enlem/Boylam",
    "general.hazards": "Tehlikeler",
    "general.speed": "Hız",
    "general.eta": "ETA",
    "general.length": "Uzunluk",
    "general.startTime": "Başlangıç zamanı:",
    "general.totalLength": "Toplam uzunluk:",
    "general.checkRouteSafety": "Rota güvenliğini kontrol et",
    "general.loading": "Yükleniyor...",
    "general.loadingEllipsis": "yükleniyor...",
    "general.pleaseSelectPng": "Lütfen bir PNG resim dosyası seçin.",
    "general.uploadImage": "Resim Yükle",
    "distributors.title": "Distribütörler",
    "distributors.subtitle": "Sertifikalı distribütörünüzü seçin",
    "distributors.agreementStatus": "Anlaşma Durumu",
    "distributors.shipInfo": "Gemi Bilgileri",
    "distributors.hasAgreement":
      "Bu gemi anlaşma kapsamında servis edilmektedir",
    "distributors.agreementDetails": "Anlaşma Detayları",
    "distributors.noAgreement": "Bu gemi herhangi bir anlaşmaya bağlı değil",
    "distributors.needAgreement":
      "Distribütör hizmetlerine erişmek için bir anlaşmaya bağlanmanız gerekiyor",
    "distributors.contactSupport": "Yardım için destek ile iletişime geçin",
    "distributors.selectDistributor": "Lütfen aşağıdan bir distribütör seçin:",
    "distributors.subscriptionOptions": "Abonelik Seçenekleri",
    "distributors.subscribe": "Abone Ol",
    "distributors.contactEmail": "Email ile İletişim",
    "distributors.location": "Konum",
    "distributors.services": "Hizmetler",
    "distributors.support": "Destek",
    "distributors.loading": "Distribütörler yükleniyor...",
    "distributors.noDistributors": "Mevcut distribütör yok",
    "distributors.error": "Distribütörler yüklenirken hata",
    "distributors.retry": "Tekrar Dene",
    "distributors.back": "Ana Sayfaya Dön",
    "distributors.selectShipFirst": "Lütfen önce bir gemi seçin",
    "distributors.agreementId": "Anlaşma ID",
    "distributors.agreementName": "Anlaşma Adı",
    "distributors.shipName": "Gemi Adı",
    "distributors.dataProvider": "Veri Sağlayıcısı",
  },
  zh: {
    "menu.fleet": "船队",
    "menu.maps": "海图",
    "menu.ships": "船舶",
    "menu.transactions": "交易",
    "menu.deliveries": "交付",
    "menu.logbook": "航海日志",
    "menu.connect": "连接",
    "menu.editor": "编辑器",
    "menu.help": "帮助",
    "tabs.ports": "港口",
    "tabs.routes": "航线",
    "tabs.settings": "设置",
    "tabs.files": "文件",
    "tabs.wp": "航点",
    "tabs.generalRoute": "General",
    "tabs.ukc": "UKC",
    "tabs.pplan": "航行计划",
    "tabs.weather": "天气",
    "tabs.folio": "海图集",
    "tabs.order": "订单",
    "btn.ok": "确定",
    "btn.cancel": "取消",
    "btn.close": "关闭",
    "btn.clear": "清除",
    "btn.submit": "提交",
    "btn.save": "保存",
    "btn.add": "添加",
    "btn.delete": "删除",
    "btn.edit": "编辑",
    "btn.search": "搜索",
    "text.internetIsLost": "网络连接已断开，网站正在受限模式下运行。",
    "menu.profile": "个人资料",
    "menu.signOut": "退出登录",
    "trans.delivery": "交付",
    "trans.afterClickOrderDownloading":
      "点击按钮后，订单将开始下载。请注意，下载可能需要几分钟时间。",
    "trans.items": "项目",
    "trans.shipName": "船名：",
    "trans.paymentBy": "支付方式：",
    "trans.agreement": "协议",
    "trans.created": "创建",
    "trans.paid": "已支付",
    "trans.cells": "单元格",
    "trans.copyENCids": "复制 ENC ID 到剪贴板",
    "trans.orderUpdates": "订单更新",
    "trans.loadingShips": "正在加载船舶...",
    "trans.loadingAgreement": "正在加载协议...",
    "trans.orderOutdated": "订单已过期",
    "trans.checkUpdates": "检查更新",
    "trans.loading": "正在加载...",
    "trans.edit": "编辑",
    "trans.request": "请求",
    "trans.topay": "待支付",
    "trans.cancel": "取消",
    "login.login": "登录",
    "login.logInToAccount": "登录您的账户",
    "login.registration": "注册",
    "login.regSuccess": "注册成功。感谢您的注册，请查看电子邮件获取密码。",
    "login.regNotSuccess": "注册失败，可能是该电子邮件已被注册。",
    "login.submit": "提交",
    "login.howToGetStarted": "如何开始",
    "login.submitYourEmail":
      "请提交您的有效电子邮件以获取密码。输入密码后即完成注册。",
    "login.howToPurchase": "如何购买 ENC",
    "login.enterCredentials":
      "输入您的凭据并选择已激活的移动设备或 ECDIS 账户以访问电子目录。",
    "login.youMayPurchase":
      "您可以购买现成的海图集，如挪威或爱沙尼亚海图集，美国海图是免费的。对于 PRIMAR，您需要从 WEB 地图或通过 Maps Booster 功能选择所需的 ENC 并进行支付。订单历史和支付记录将被保存。",
    "login.systemAutoPrevents":
      "系统会自动防止您重复购买海图，并可以通过自动计算和图形编辑器修正的航线帮助您选择海图。",
    "login.news": "新闻",
    "mobile.rotatePhone": "将手机旋转至横屏并点击登录按钮",
    "mobile.login": "登录",
    "payment.returnToOrders": "返回您的订单",
    "reg.registration": "注册",
    "reg.regSuccess": "注册成功。感谢您的注册，请查看电子邮件获取密码。",
    "reg.regNotSuccess": "注册失败，可能是该电子邮件已被注册。",
    "reg.submit": "提交",
    "reg.incorrectPassword": "密码错误，请重试。",
    "ships.edit": "编辑",
    "ships.details": "详情",
    "ships.deviceId": "设备 ID：",
    "ships.email": "电子邮件：",
    "ships.shipName": "船名：",
    "ships.category": "类别：",
    "ships.type": "类型：",
    "ships.brand": "ECDIS 品牌：",
    "ships.imo": "IMO：",
    "ships.callsign": "呼号：",
    "ships.permit": "许可证：",
    "ships.license": "许可证：",
    "ships.licenseType": "许可证类型：",
    "ships.licenseValid": "许可证有效期：",
    "ships.emails": "通知电子邮件：",
    "ships.delveryEmails": "交付电子邮件：",
    "ships.charts": "海图：",
    "ships.expired": "已过期",
    "ships.loadingInstllations": "正在加载安装...",
    "ships.noInfo": "无船舶信息可用。请扫描 ECDIS 的二维码以读取船舶信息。",
    "ships.qrcode": "二维码",
    "ships.report": "报告",
    "ships.onmap": "在地图上",
    "ships.view": "查看",
    "ships.clear": "清除",
    "ships.byqrcode": "通过二维码",
    "ships.manually": "手动",
    "ships.selected": "已选择",
    "ships.notSelected": "未选择",
    "ship.addShip": "添加船舶",
    "ship.shipName": "船名",
    "ship.edit": "编辑",
    "ship.report": "报告",
    "ship.viewEdit": "查看/编辑船舶",
    "ship.selectProvider": "选择数据提供商",
    "ship.id": "ID",
    "ship.band": "波段",
    "ship.ordered": "已订购",
    "ship.daysValid": "有效天数",
    "ships.mmsi": "MMSI：",
    "ships.callSign": "呼号：",
    "ships.country": "国家：",
    "ships.length": "长度：",
    "ships.width": "宽度：",
    "ships.height": "高度：",
    "ships.draught": "吃水：",
    "ships.shipCategory": "船舶类别：",
    "ships.os": "ECDIS 操作系统：",
    "ships.permit1": "备用许可证 1：",
    "ships.permit2": "备用许可证 2：",
    "payment.placingOrder": "正在提交您的订单...",
    "payment.clickToPayment": "点击进入支付",
    "logbook.loadingShips": "正在加载船舶...",
    "logbook.loadingAgreements": "正在加载协议...",
    "logbook.addReport": "添加报告",
    "logbook.lat": "LAT",
    "logbook.lon": "LON",
    "logbook.hdg": "HDG",
    "logbook.sog": "SOG",
    "logbook.message": "消息",
    "logbook.cancel": "取消",
    "logbook.saveReport": "保存报告",
    "logbook.link": "链接",
    "logbook.ecdis": "ECDIS",
    "editor.cancel": "取消",
    "editor.save": "保存",
    "ecdis.ecdis": "ECDIS",
    "ecdis.save": "保存",
    "ecdis.add": "添加",
    "ecdis.nowYouCan": "现在您可以访问",
    "ecdis.andSelect": "选项卡并选择 ECDIS 设备以购买海图。",
    "ecdis.mydevices": "我的设备",
    "connect.loadingShips": "正在加载船舶...",
    "connect.loadingAgreements": "正在加载协议...",
    "agreement.statusOwner": "状态：所有者",
    "agreement.agrements": "协议",
    "agreement.loadings": "正在加载...",
    "agreement.noAgreements": "无协议",
    "deliveries.loadingShips": "正在加载船舶...",
    "deliveries.loadingAgreements": "正在加载协议...",
    "deliveries.checkUpdates": "检查更新",
    "deliveries.loading": "正在加载...",
    "deliveries.download": "下载",
    "routes.trafficSepZone": "分道通航区",
    "routes.inshoreTrafZone": "沿岸通航区",
    "routes.restArea": "限制区域",
    "routes.cautionArea": "注意区域",
    "routes.offshoreProdArea": "离岸生产区",
    "routes.avoidedArea": "避航区",
    "routes.militaryArea": "军事演习区",
    "routes.seaplaneArea": "水上飞机降落区",
    "routes.submarineLine": "潜艇航道",
    "routes.anchorageArea": "锚地区",
    "routes.marineFarm": "海洋养殖区",
    "routes.pssa": "特别敏感海域",
    "routes.showWind": "显示风",
    "routes.showTemp": "显示温度",
    "routes.selectDateTime": "请先选择日期/时间",
    "routes.weatherNotAvailable": "航线天气不可用，请重新计算",
    "routes.weatherNotAvailableForRoute": "航线天气不可用",
    "routes.loadingWeather": "正在加载天气...",
    "routes.from": "从",
    "routes.to": "到",
    "routes.nogo": "禁航区",
    "routes.draught": "吃水",
    "routes.route": "航线",
    "routes.change": "更改",
    "routes.clear": "清除",
    "routes.searching": "正在搜索...",
    "routes.showHazards": "显示危险",
    "routes.showOnlyDangers": "仅显示危险航段",
    "routes.detailed": "详细",
    "routes.general": "常规",
    "routes.filtered": "已筛选",
    "routes.connect": "连接",
    "routes.cancel": "取消",
    "routesettings.nogo": "禁航区 (米)",
    "route.dateToFar":
      "日期太远，无法获取潮汐预报。请输入新日期以获取最新预报。",
    "route.loading": "正在加载...",
    "route.submit": "提交",
    "route.update": "更新",
    "route.calculatingPrice": "正在计算价格...",
    "route.ovr": "总览",
    "route.gnr": "常规",
    "route.cst": "沿岸",
    "route.apr": "进港",
    "route.hrb": "港口",
    "route.brg": "靠泊",
    "route.less30": "少于 30 天",
    "route.infolio": "在海图集中",
    "route.selected": "已选择",
    "route.unselected": "未选择",
    "route.multiple": "多个",
    "route.approve": "批准",
    "route.cancel": "取消",
    "route.pleaseWait": "请稍候...",
    "route.downloadpdf": "下载 PDF",
    "route.import": "导入",
    "route.order": "订单",
    "route.routeName": "航线名称",
    "route.change": "更改",
    "route.nogo": "禁航区：",
    "route.draught": "吃水",
    "route.length": "长度",
    "route.width": "宽度",
    "route.height": "高度",
    "route.displacement": "排水量",
    "route.checkRouteFirst": "您需要先检查航线安全性。",
    "route.contractExpired": "该船的服务合同已过期，请签订新合同。",
    "route.noContract": "该船未签订服务合同，您可以为其签订合同。",
    "route.loadingCatalog": "正在加载目录...",
    "route.loadingProducts": "正在加载航线产品...",
    "route.Loading": "正在加载...",
    "route.loadingShips": "正在加载船舶...",
    "route.loadingAgreements": "正在加载协议...",
    "route.safetyCalculation": "航线/安全性计算中...",
    "route.calculation": "安全性计算中...",
    "route.loadZones": "加载区域",
    "route.loadPaths": "加载路径",
    "route.loadRTZ": "加载 RTZ",
    "route.saveRTZ": "保存 RTZ",
    "route.search": "搜索",
    "route.settings": "设置",
    "route.mapInfo": "地图信息",
    "route.addShip": "在航线规划前，添加船舶到账户",
    "route.calculatedTime": "航线计算时间：",
    "route.seconds": "秒",
    "route.totalWP": "总航点",
    "route.totalSegments": "Total segments",
    "route.totalLength": "总长度",
    "route.estimatedLength": "预计长度",
    "route.startTime": "开始时间",
    "route.ETA": "ETA",
    "route.latlon": "LAT/LON",
    "route.hazards": "危险",
    "route.speed": "速度",
    "route.saveRoute": "保存航线",
    "route.enterRouteName": "输入航线名称",
    "route.typeToSearch": "输入以搜索",
    "route.name": "名称",
    "route.start": "开始",
    "route.finish": "结束",
    "route.autoRouting": "自动航线规划",
    "route.general": "常规",
    "route.detailed": "详细",
    "route.m": "米",
    "route.updateGeneral": "Update General Route",
    "settings.reset": "重置设置",
    "settings.nogo": "禁航区 (米)",
    "settings.draught": "吃水 (米)",
    "settings.height": "高度 (米)",
    "settings.length": "长度 (米)",
    "settings.width": "宽度 (米)",
    "settings.displacement": "排水量 (吨)",
    "settings.radius": "半径 (米)",
    "settings.xtl": "XTE.L (米)",
    "settings.xtr": "XTE.R (米)",
    "settings.speed": "速度 (节)",
    "settings.trackRatio": "航迹比例",
    "settings.shallowRatio": "浅水比例",
    "settings.avoidShallowStrength": "避浅强度",
    "settings.avoidDistance": "避让距离 (米)",
    "settings.refineCoeff": "优化系数",
    "settings.startDate": "开始日期",
    "settings.startTime": "开始时间",
    "settings.allowSuez": "允许苏伊士运河",
    "settings.allowPanama": "允许巴拿马运河",
    "settings.allowBering": "允许白令海峡",
    "settings.allowRivers": "允许河流",
    "settings.recommendedTracks": "推荐航迹",
    "settings.generalRoutes": "仅常规航线",
    "settings.graphRouteScoreFactor": "Graph weight",
    "settings.landAroundScoreFactor": "Land contour weight",
    "settings.linkHeuristicFactor": "Link heuristic factor",
    "settings.waterScoreFactor": "Graph water weight",
    "settings.previewLandContour": "Preview land contour",
    "settings.graphDiag": "Show graph diagnostics",
    "settings.nearestPointsNumber": "Graph points",
    "settings.tiles": "瓦片",
    "msg.agreementWarning": "协议警告",
    "msg.routeValidation": "Route validation",
    "editor.loadingWarning": "加载将替换所有现有数据，是否继续？",
    "editor.editor": "编辑器",
    "editor.load": "加载",
    "editor.clear": "清除",
    "editor.export": "导出选定线路",
    "connect.connectPanel": "连接面板",
    "connect.getPosition": "获取位置",
    "connect.getStatus": "获取状态",
    "connect.getRoute": "获取航线",
    "connect.getFolio": "获取海图集",
    "connect.requesting": "正在请求...",
    "logbook.logbook": "航海日志",
    "logbook.images": "图像",
    "logbook.audio": "音频",
    "logbook.selectImages": "选择图像...",
    "deliveries.deliveries": "交付",
    "deliveries.content": "内容",
    "deliveries.type": "类型",
    "deliveries.date": "日期",
    "deliveries.size": "大小",
    "deliveries.bytes": "字节",
    "deliveries.kib": "KiB",
    "deliveries.mib": "MiB",
    "deliveries.gib": "GiB",
    "deliveries.tib": "TiB",
    "deliveries.pib": "PiB",
    "deliveries.eib": "EiB",
    "deliveries.zib": "ZiB",
    "deliveries.yib": "YiB",
    "deliveries.fullSet": "完整集",
    "deliveries.regularUpdate": "定期更新",
    "deliveries.order": "订单",
    "transactions.transaction": "交易",
    "transactions.request": "请求",
    "transactions.toPay": "待支付",
    "transactions.processing": "处理中",
    "transactions.complete": "完成",
    "transactions.error": "错误",
    "transactions.notFound": "未找到",
    "transactions.pending": "待处理",
    "transactions.downloading": "海图下载中",
    "transactions.cancel": "已取消",
    "transactions.status": "状态",
    "transactions.id": "ID",
    "transactions.date": "日期",
    "transactions.customer": "客户",
    "transactions.ship": "船舶",
    "transactions.content": "内容",
    "transactions.payment": "支付",
    "transactions.price": "价格",
    "transactions.updated": "更新",
    "transactions.user": "用户",
    "order.validTill": "有效期至",
    "order.band": "波段",
    "order.name": "名称",
    "order.price": "价格",
    "order.ai": "AI",
    "order.till": "至",
    "bands.overview": "总览",
    "bands.general": "常规",
    "bands.coastal": "沿岸",
    "bands.approach": "进港",
    "bands.harbour": "港口",
    "bands.berthing": "靠泊",
    "order.period": "周期",
    "order.totalPrice": "总价",
    "order.items": "项目",
    "order.months": "月",
    "order.agreement": "协议",
    "order.ship": "船舶",
    "order.selected": "已选择",
    "order.id": "ID",
    "order.importList": "导入单元格列表",
    "order.pastList": "粘贴逗号或换行分隔的单元格名称...",
    "order.availableAVCS": "可用 AVCS",
    "order.availableADP": "可用 ADP",
    "order.availableENP": "可用 eNP",
    "order.availableENC": "可用 ENC",
    "order.timeUTC": "UTC 时间",
    "order.chartD": "海图.D 米",
    "order.safeRoute": "安全航线",
    "order.safeD": "安全.D 米",
    "order.ukc": "UKC 米",
    "order.openWaters": "开阔水域",
    "order.draft": "吃水",
    "order.speed": "速度 节",
    "order.disp": "排水量 吨",
    "order.policy": "策略 米",
    "order.swuat": "下沉 米",
    "order.tide": "潮汐 米",
    "order.zoc": "ZOC 米",
    "order.yes": "是",
    "order.no": "否",
    "order.length": "长度",
    "order.width": "宽度",
    "order.displacement": "排水量",
    "order.m": "米",
    "order.t": "吨",
    "order.eta": "ETA",
    "order.wind": "风",
    "order.direction": "方向",
    "order.ms": "米/秒",
    "order.routeStartTime": "航线开始时间：",
    "map.editNoGoZones": "编辑禁航区",
    "map.exitEditing": "退出编辑",
    "map.makeNavRoute": "安全性计算中",
    "map.clearRoute": "清除航线",
    "map.clearRoutePrompt": "路线清晰",
    "map.clearRouteHint": "清除整个航线和航点",
    "map.checkPointSafety": "检查点安全性",
    "map.checkPointSafetyHint": "检查点的安全性",
    "map.checkRouteSafety": "检查航线安全性",
    "map.checkRouteSafetyHint": "检查航线的安全性",
    "map.recalculateRoute": "重新计算航线",
    "map.recalculateRouteHint": "重新计算航线的安全性",
    "map.recalculatePoint": "重新计算点",
    "map.recalculatePointHint": "重新计算点的安全性",
    "map.movePoint": "向移动点",
    "map.movePointLeft": "向左移动点",
    "map.movePointUp": "向上移动点",
    "map.movePointDown": "向下移动点",
    "map.movePointRight": "向右移动点",
    "map.moveLegLeft": "向左移动航段",
    "map.moveLegUp": "向上移动航段",
    "map.moveLegDown": "向下移动航段",
    "map.moveLegRight": "向右移动航段",
    "map.removePoint": "移除点",
    "map.start": "开始",
    "map.add": "添加",
    "map.insert": "插入",
    "map.finish": "结束",
    "map.move": "移动",
    "map.nogo": "禁航区：",
    "map.m": "米",
    "fleet.fleet": "船队",
    "fleet.online": "在线",
    "fleet.offline": "离线",
    "fleet.alarm": "警报",
    "fleet.imo": "IMO",
    "fleet.edit": "编辑船舶",
    "fleet.upn": "UPN",
    "fleet.folio": "海图集",
    "fleet.updates": "更新",
    "fleet.available": "可用",
    "fleet.orders": "订单",
    "fleet.addOrder": "添加订单",
    "fleet.latestReport": "最新报告",
    "fleet.viewReports": "查看报告",
    "fleet.status": "状态",
    "fleet.noMapsForRoute": "航线海图不足",
    "fleet.pressToAddShip": "未找到船舶",
    "fleet.noShipsFound": "点击添加船舶",
    "fleet.addShip": "添加",
    "fleet.addECDIS": "添加 ECDIS",
    "fleet.addByQR": "通过二维码添加",
    "fleet.addManually": "手动添加",
    "fleet.account": "账户",
    "fleet.latest": "最新",
    "fleet.more": "更多",
    "fleet.noOrders": "无订单",
    "fleet.deliveries": "交付",
    "fleet.deviceid": "设备ID",
    "general.autoband": "自动波段",
    "general.overview": "概览",
    "general.distributors": "分销商",
    "general.geoPhone": "GeoPhone Group International OY",
    "general.distributorsList": "请在下方查看我们认证分销商的列表。",
    "general.loadingFleetData": "加载船队数据",
    "general.noPosition": "无位置",
    "general.dataProvider": "数据提供商",
    "general.latLon": "纬度/经度",
    "general.hazards": "危险",
    "general.speed": "速度",
    "general.eta": "ETA",
    "general.length": "长度",
    "general.startTime": "开始时间:",
    "general.totalLength": "总长度:",
    "general.checkRouteSafety": "检查路线安全",
    "general.loading": "加载中...",
    "general.loadingEllipsis": "加载中...",
    "general.pleaseSelectPng": "请选择一个PNG图像文件。",
    "general.uploadImage": "上传图片",
    "distributors.title": "分销商",
    "distributors.subtitle": "选择您的认证分销商",
    "distributors.agreementStatus": "协议状态",
    "distributors.shipInfo": "船舶信息",
    "distributors.hasAgreement": "该船舶在协议服务范围内",
    "distributors.agreementDetails": "协议详情",
    "distributors.noAgreement": "该船舶未连接到任何协议",
    "distributors.needAgreement": "要访问分销商服务，您需要连接到协议",
    "distributors.contactSupport": "联系支持寻求帮助",
    "distributors.selectDistributor": "请在下方选择一个分销商：",
    "distributors.subscriptionOptions": "订阅选项",
    "distributors.subscribe": "订阅",
    "distributors.contactEmail": "邮件联系",
    "distributors.location": "位置",
    "distributors.services": "服务",
    "distributors.support": "支持",
    "distributors.loading": "正在加载分销商...",
    "distributors.noDistributors": "没有可用的分销商",
    "distributors.error": "加载分销商时出错",
    "distributors.retry": "重试",
    "distributors.back": "返回主页",
    "distributors.selectShipFirst": "请先选择一艘船",
    "distributors.agreementId": "协议ID",
    "distributors.agreementName": "协议名称",
    "distributors.shipName": "船舶名称",
    "distributors.dataProvider": "数据提供商",
  },
};

// {{ $t('menu.transactions') }}

// Create i18n instance
const i18n = new VueI18n({
  locale: "en", // default locale
  fallbackLocale: "en",
  messages,
});

export default i18n;
